export const t = {
  welcome_to_firemenu: {
    uk: 'Вітаємо у FireMenu!',
    en: 'Welcome to FireMenu!',
    es: '¡Bienvenido a FireMenu!',
    ru: 'Добро пожаловать в FireMenu!',
  },
  firemenu_works_in_browser: {
    uk: 'FireMenu працює у браузері, але для вашої зручності ми пропонуємо встановити застосунок.',
    en: 'FireMenu works in the browser, but for your convenience, we offer to install the app.',
    es: 'FireMenu funciona en el navegador, pero para su comodidad, ofrecemos instalar la aplicación.',
    ru: 'FireMenu работает в браузере, но для вашего удобства мы предлагаем установить приложение.',
  },
  install_the_app: {
    uk: 'Встановити застосунок',
    en: 'Install the App',
    es: 'Instalar la Aplicación',
    ru: 'Установить приложение',
  },
  continue_in_browser: {
    uk: 'Продовжити в браузері',
    en: 'Continue in Browser',
    es: 'Continuar en el Navegador',
    ru: 'Продолжить в браузере',
  },
  please_login: {
    uk: 'Будь ласка, авторизуйтесь',
    en: 'Please login',
    es: 'Por favor, inicie sesión',
    ru: 'Пожалуйста, войдите в систему',
  },
  registration: {
    uk: 'Реєстрація',
    en: 'Registration',
    es: 'Registro',
    ru: 'Регистрация',
  },
  login: {
    uk: 'Увійти',
    en: 'Sign in',
    es: 'Iniciar sesión',
    ru: 'Войти',
  },
  login_with_google: {
    uk: 'Увійти з Google',
    en: 'Sign in with Google',
    es: 'Iniciar sesión con Google',
    ru: 'Войти с Google',
  },
  register: {
    uk: 'Зареєструватися',
    en: 'Sign up',
    es: 'Regístrese',
    ru: 'Зарегистрироваться',
  },
  register_with_phone: {
    uk: 'Зареєструватися з телефоном',
    en: 'Sign up with your phone',
    es: 'Regístrese con teléfono',
    ru: 'Зарегистрироваться с телефоном',
  },
  register_with_google: {
    uk: 'Зареєструватися з Google',
    en: 'Sign up with Google',
    es: 'Regístrese con Google',
    ru: 'Зарегистрироваться с Google',
  },
  login_with_phone: {
    uk: 'Увійти з телефоном',
    en: 'Sign in with your phone',
    es: 'Inicia sesión con teléfono',
    ru: 'Войти с телефоном',
  },
  or: {
    uk: 'Або',
    en: 'Or',
    es: 'O',
    ru: 'Или',
  },
  code: {
    uk: 'SMS код',
    en: 'SMS Code',
    es: 'Código SMS',
    ru: 'SMS код',
  },
  confirm: {
    uk: 'Підтвердити',
    en: 'Confirm',
    es: 'Confirmar',
    ru: 'Подтвердить',
  },
  sms_code_sent: {
    uk: 'На Ваш номер телефону було надіслано SMS код',
    en: 'An SMS code has been sent to your phone number',
    es: 'Se ha enviado un código SMS a su número de teléfono',
    ru: 'На Ваш номер телефона был отправлен SMS код',
  },
  settings: {
    uk: 'Налаштування',
    en: 'Settings',
    es: 'Ajustes',
    ru: 'Настройки',
  },
  sing_out: {
    uk: 'Вийти',
    en: 'Sing out',
    es: 'Cerrar sesión',
    ru: 'Выйти',
  },
  welcome_to: {
    uk: 'Ласкаво просимо до',
    en: 'Welcome to',
    es: 'Bienvenido a',
    ru: 'Добро пожаловать в',
  },
  create_cafe_info: {
    uk: 'Схоже, обліковий запис для вашого закладу ще не створено. Натисніть «Створити заклад», щоб продовжити.',
    en: 'It seems that an account has not yet been created for your restaurant. Click "Create restaurant" to continue.',
    es: 'Parece que aún no se ha creado una cuenta para su restaurante. Haga clic en "Crear restaurante" para continuar.',
    ru: 'Похоже, учетная запись для вашего заведения еще не создана. Нажмите «Создать заведение», чтобы продолжить.',
  },
  my_cafes: {
    uk: 'Мої заклади',
    en: 'My restaurants',
    es: 'Mis restaurantes',
    ru: 'Мои заведения',
  },
  create_cafe: {
    uk: 'Створити заклад',
    en: 'Create restaurant',
    es: 'Crear restaurante',
    ru: 'Создать заведение',
  },
  cafe_name: {
    uk: 'Назва закладу',
    en: 'Restaurant name',
    es: 'Nombre del restaurante',
    ru: 'Название заведения',
  },
  create: {
    uk: 'Створити',
    en: 'Create',
    es: 'Crear',
    ru: 'Создать',
  },
  currency: {
    uk: 'Валюта',
    en: 'Currency',
    es: 'Moneda',
    ru: 'Валюта',
  },
  '₴': {
    uk: 'Гривня',
    en: 'UAH',
    es: 'UAH',
    ru: 'Гривна',
  },
  '€': {
    uk: 'Євро',
    en: 'EUR',
    es: 'EUR',
    ru: 'Евро',
  },
  primary: {
    uk: 'Основне',
    en: 'Primary',
    es: 'Principal',
    ru: 'Основное',
  },
  menu: {
    uk: 'Меню',
    en: 'Menu',
    es: 'Menú',
    ru: 'Меню',
  },
  store: {
    uk: 'Склад',
    en: 'Storage',
    es: 'Almacenamiento',
    ru: 'Склад',
  },
  shift: {
    uk: 'Робоча зміна',
    en: 'Work shift',
    es: 'Turno de trabajo',
    ru: 'Рабочая смена',
  },
  add_shift: {
    uk: 'Додати робочу зміну',
    en: 'Add work shift',
    es: 'Agregar turno de trabajo',
    ru: 'Добавить рабочую смену',
  },
  stores: {
    uk: 'Склади',
    en: 'Storages',
    es: 'Almacenamientos',
    ru: 'Склады',
  },
  staff: {
    uk: 'Персонал',
    en: 'Staff',
    es: 'Personal',
    ru: 'Персонал',
  },
  journal: {
    uk: 'Графік змін',
    en: 'Schedule',
    es: 'Horario',
    ru: 'График смен',
  },
  workers: {
    uk: 'Працівники',
    en: 'Employees',
    es: 'Trabajadores',
    ru: 'Сотрудники',
  },
  worker: {
    uk: 'Працівник',
    en: 'Employee',
    es: 'Empleado',
    ru: 'Сотрудник',
  },
  workerName: {
    uk: 'Працівник',
    en: 'Employee',
    es: 'Nombre del empleado',
    ru: 'Имя сотрудника',
  },
  dashboard: {
    uk: 'Основні показники',
    en: 'Dashboard',
    es: 'Tablero',
    ru: 'Основные показатели',
  },
  product: {
    uk: 'Продукт',
    en: 'Product',
    es: 'Producto',
    ru: 'Продукт',
  },
  products: {
    uk: 'Продукти',
    en: 'Products',
    es: 'Productos',
    ru: 'Продукты',
  },
  name: {
    uk: 'Назва',
    en: 'Name',
    es: 'Nombre',
    ru: 'Название',
  },
  userName: {
    uk: `Ім'я`,
    en: 'Name',
    es: 'Nombre',
    ru: 'Имя',
  },
  unit: {
    uk: 'Одиниця виміру',
    en: 'Unit',
    es: 'Unidad',
    ru: 'Единица измерения',
  },
  packaging: {
    uk: 'Упаковка',
    en: 'Packaging',
    es: 'Embalaje',
    ru: 'Упаковка',
  },
  pac: {
    uk: 'уп',
    en: 'pac',
    es: 'pac',
    ru: 'уп',
  },
  article: {
    uk: 'Артикул',
    en: 'Article',
    es: 'Artículo',
    ru: 'Артикул',
  },
  provider: {
    uk: 'Постачальник',
    en: 'Provider',
    es: 'Proveedor',
    ru: 'Поставщик',
  },
  category: {
    uk: 'Категорія',
    en: 'Category',
    es: 'Categoría',
    ru: 'Категория',
  },
  quantity_per_package: {
    uk: 'К-ть в упаковці',
    en: 'Quantity per package',
    es: 'Cantidad por paquete',
    ru: 'К-ть в упаковке',
  },
  in: {
    uk: 'в',
    en: 'in',
    es: 'en',
    ru: 'в',
  },
  remove: {
    uk: 'Видалити',
    en: 'Remove',
    es: 'Eliminar',
    ru: 'Удалить',
  },
  remove_wallet_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цей рахунок?',
    en: 'Are you sure you want to delete this wallet?',
    es: '¿Estás seguro de que deseas eliminar esta billetera?',
    ru: 'Вы уверены, что хотите удалить этот счет?',
  },
  remove_worker_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цього працівника?',
    en: 'Are you sure you want to delete this employee?',
    es: '¿Estás seguro de que deseas eliminar a este empleado?',
    ru: 'Вы уверены, что хотите удалить этого сотрудника?',
  },
  remove_product_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цей продукт?',
    en: 'Are you sure you want to remove this product?',
    es: '¿Estás seguro de que deseas eliminar este producto?',
    ru: 'Вы уверены, что хотите удалить этот продукт?',
  },
  remove_legal_entity_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цю юридичну особу?',
    en: 'Are you sure you want to delete this legal entity?',
    es: '¿Está seguro de que desea eliminar esta entidad legal?',
    ru: 'Вы уверены, что хотите удалить эту юридическую лицо?',
  },
  remove_self_order_point_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цю точку самозамовлення?',
    en: 'Are you sure you want to delete this self-ordering kiosk?',
    es: '¿Está seguro de que desea eliminar este quiosco de auto-pedido?',
    ru: 'Вы уверены, что хотите удалить эту точку самообслуживания?',
  },
  remove_section_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цей розділ меню?',
    en: 'Are you sure you want to remove this menu section?',
    es: '¿Estás seguro de que deseas eliminar esta sección del menú?',
    ru: 'Вы уверены, что хотите удалить этот раздел меню?',
  },
  remove_category_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цю категорію?',
    en: 'Are you sure you want to remove this menu category?',
    es: '¿Estás seguro de que deseas eliminar esta categoría de menú?',
    ru: 'Вы уверены, что хотите удалить эту категорию?',
  },
  remove_dish_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цю позицію?',
    en: 'Are you sure you want to remove this menu item?',
    es: '¿Estás seguro de que deseas eliminar esta plato?',
    ru: 'Вы уверены, что хотите удалить эту позицию?',
  },
  remove_store_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цей склад?',
    en: 'Are you sure you want to remove this storage?',
    es: '¿Estás seguro de que deseas eliminar este almacenamiento?',
    ru: 'Вы уверены, что хотите удалить этот склад?',
  },
  remove_shift_confirm: {
    uk: 'Ви впевнені, що бажаєте видалити цю зміну?',
    en: 'Are you sure you want to remove this shift?',
    es: '¿Estás seguro de que deseas eliminar este turno?',
    ru: 'Вы уверены, что хотите удалить эту смену?',
  },
  cancel_wallet_action_confirm: {
    uk: 'Ви впевнені, що бажаєте відмінити цю подію?',
    en: 'Are you sure you want to cancel this event?',
    es: '¿Estás seguro de que deseas cancelar este evento?',
    ru: 'Вы уверены, что хотите отменить это событие?',
  },
  cancel_reservation_confirm: {
    uk: 'Ви впевнені, що бажаєте скасувати це бронювання?',
    en: 'Are you sure you want to cancel this booking?',
    es: '¿Está seguro de que desea cancelar esta reserva?',
    ru: 'Вы уверены, что хотите отменить это бронирование?',
  },
  confirm_delete_client_or_group: {
    uk: 'Ви впевнені, що бажаєте видалити цього клієнта/групу?',
    en: 'Are you sure you want to delete this client/group?',
    es: '¿Está seguro de que desea eliminar este cliente/grupo?',
    ru: 'Вы уверены, что хотите удалить этого клиента/группу?',
  },
  cancel_booking: {
    uk: 'Скасувати бронювання',
    en: 'Cancel Booking',
    es: 'Cancelar Reserva',
    ru: 'Отменить бронирование',
  },
  save_changes: {
    uk: 'Зберегти зміни',
    en: 'Save changes',
    es: 'Guardar cambios',
    ru: 'Сохранить изменения',
  },
  save: {
    uk: 'Зберегти',
    en: 'Save',
    es: 'Guardar',
    ru: 'Сохранить',
  },
  yes: {
    uk: 'Так',
    en: 'Yes',
    es: 'Sí',
    ru: 'Да',
  },
  no: {
    uk: 'Ні',
    en: 'No',
    es: 'No',
    ru: 'Нет',
  },
  cancel: {
    uk: 'Скасувати',
    en: 'Cancel',
    es: 'Cancelar',
    ru: 'Отменить',
  },
  add: {
    uk: 'Додати',
    en: 'Add',
    es: 'Agregar',
    ru: 'Добавить',
  },
  add_product: {
    uk: 'Додати продукт',
    en: 'Add a product',
    es: 'Agregar un producto',
    ru: 'Добавить продукт',
  },
  add_employee: {
    uk: 'Додати працівника',
    en: 'Add an employee',
    es: 'Agregar un empleado',
    ru: 'Добавить сотрудника',
  },
  add_wallet: {
    uk: 'Додати рахунок',
    en: 'Add a wallet',
    es: 'Agregar una billetera',
    ru: 'Добавить счет',
  },
  wallet: {
    uk: 'Рахунок',
    en: 'Wallet',
    es: 'Billetera',
    ru: 'Счет',
  },
  to_wallet: {
    uk: 'На рахунок',
    en: 'To wallet',
    es: 'A la billetera',
    ru: 'На счет',
  },
  wallets: {
    uk: 'Рахунки',
    en: 'Wallets',
    es: 'Billeteras',
    ru: 'Счета',
  },
  add_semi_product: {
    uk: 'Додати напівфабрикат',
    en: 'Add a semi-finished product',
    es: 'Agregar un producto semielaborado',
    ru: 'Добавить полуфабрикат',
  },
  add_store: {
    uk: 'Додати склад',
    en: 'Add a storage',
    es: 'Agregar un almacenamiento',
    ru: 'Добавить склад',
  },
  add_dish: {
    uk: 'Додати позицію',
    en: 'Add a menu item',
    es: 'Agregar un plato',
    ru: 'Добавить позицию',
  },
  download_image: {
    uk: 'Завантажити зображення',
    en: 'Download image',
    es: 'Descargar imagen',
    ru: 'Загрузить изображение',
  },
  pc: {
    uk: 'шт',
    en: 'pc',
    es: 'pc',
    ru: 'шт',
  },
  g: {
    uk: 'г',
    en: 'g',
    es: 'g',
    ru: 'г',
  },
  ml: {
    uk: 'мл',
    en: 'ml',
    es: 'ml',
    ru: 'мл',
  },
  kg: {
    uk: 'кг',
    en: 'kg',
    es: 'kg',
    ru: 'кг',
  },
  l: {
    uk: 'л',
    en: 'l',
    es: 'l',
    ru: 'л',
  },
  edit: {
    uk: 'Редагувати',
    en: 'Edit',
    es: 'Editar',
    ru: 'Редактировать',
  },
  search: {
    uk: 'Пошук',
    en: 'Search',
    es: 'Buscar',
    ru: 'Поиск',
  },
  empty_search_message: {
    uk: 'За цими пошуковими параметрами нічого не знайдено. Спробуйте змінити параметри пошуку.',
    en: 'No results were found for these search parameters. Try changing your search parameters.',
    es: 'No se encontraron resultados para estos parámetros de búsqueda. Intente cambiar sus parámetros de búsqueda.',
    ru: 'По этим поисковым параметрам ничего не найдено. Попробуйте изменить параметры поиска.',
  },
  clear_filters: {
    uk: 'Очистити фільтри',
    en: 'Clear filters',
    es: 'Limpiar filtros',
    ru: 'Очистить фильтры',
  },
  there_is_nothing: {
    uk: 'Здається, тут ще нічого немає',
    en: 'It seems that there is nothing here yet',
    es: 'Parece que aún no hay nada aquí',
    ru: 'Кажется, здесь еще ничего нет',
  },
  semifinished_product: {
    uk: 'Напівфабрикат',
    en: 'Semi-finished product',
    es: 'Producto semielaborado',
    ru: 'Полуфабрикат',
  },
  semifinished_products: {
    uk: 'Напівфабрикати',
    en: 'Semi-finished products',
    es: 'Productos semielaborados',
    ru: 'Полуфабрикаты',
  },
  add_component: {
    uk: 'Додати компонент',
    en: 'Add a component',
    es: 'Añadir un componente',
    ru: 'Добавить компонент',
  },
  component: {
    uk: 'Компонент',
    en: 'Component',
    es: 'Componente',
    ru: 'Компонент',
  },
  select_component: {
    uk: 'Оберіть компонент',
    en: 'Select a component',
    es: 'Seleccione un componente',
    ru: 'Выберите компонент',
  },
  costs_of_production: {
    uk: 'Витрати на виготовлення',
    en: 'Costs of production',
    es: 'Costos de producción',
    ru: 'Затраты на производство',
  },
  add_costs_of_production: {
    uk: 'Додати витрати на виготовлення',
    en: 'Add costs of production',
    es: 'Agregar costos de producción',
    ru: 'Добавить затраты на производство',
  },
  add_menu_section: {
    uk: 'Додати розділ меню',
    en: 'Add menu section',
    es: 'Añadir sección de menú',
    ru: 'Добавить раздел меню',
  },
  add_category: {
    uk: 'Додати категорію',
    en: 'Add category',
    es: 'Añadir categoría',
    ru: 'Добавить категорию',
  },
  menu_section: {
    uk: 'Розділ меню',
    en: 'Menu section',
    es: 'Sección del menú',
    ru: 'Раздел меню',
  },
  menu_sections: {
    uk: 'Розділи меню',
    en: 'Menu sections',
    es: 'Secciones del menú',
    ru: 'Разделы меню',
  },
  category_description: {
    uk: 'Опис категорії',
    en: 'Category description',
    es: 'Descripción de la categoría',
    ru: 'Описание категории',
  },
  show_category_for_visitors: {
    uk: 'Відображати категорію для відвідувачів',
    en: 'Show this category for visitors',
    es: 'Mostrar esta categoría para visitantes',
    ru: 'Показывать эту категорию для посетителей',
  },
  show_section_for_visitors: {
    uk: 'Відображати розділ для відвідувачів',
    en: 'Show this section for visitors',
    es: 'Mostrar esta sección a los visitantes',
    ru: 'Показывать этот раздел для посетителей',
  },
  show_for_visitors: {
    uk: 'Відображати для відвідувачів',
    en: 'Show for visitors',
    es: 'Mostrar a los visitantes',
    ru: 'Показывать для посетителей',
  },
  active_categories: {
    uk: 'Активних категорій',
    en: 'Active categories',
    es: 'Categorías activas',
    ru: 'Активные категории',
  },
  hidden_categories: {
    uk: 'Прихованих категорій',
    en: 'Hidden categories',
    es: 'Categorías ocultas',
    ru: 'Скрытые категории',
  },
  active_items: {
    uk: 'Активних елементів',
    en: 'Active elements',
    es: 'Elementos activos',
    ru: 'Активные элементы',
  },
  hidden_items: {
    uk: 'Прихованих елементів',
    en: 'Hidden elements',
    es: 'Elementos ocultos',
    ru: 'Скрытые элементы',
  },
  go_to_categories: {
    uk: 'Перейти до категорій',
    en: 'Go to categories',
    es: 'Ir a categorías',
    ru: 'Перейти к категориям',
  },
  description: {
    uk: 'Опис',
    en: 'Description',
    es: 'Descripción',
    ru: 'Описание',
  },
  visibility: {
    uk: 'Видимість',
    en: 'Visibility',
    es: 'Visibilidad',
    ru: 'Видимость',
  },
  price: {
    uk: 'Ціна',
    en: 'Price',
    es: 'Precio',
    ru: 'Цена',
  },
  cooking_time: {
    uk: 'Час приготування',
    en: 'Cooking time',
    es: 'Tiempo de cocción',
    ru: 'Время приготовления',
  },
  minutes_short: {
    uk: 'хв',
    en: 'min',
    es: 'min',
    ru: 'мин',
  },
  menu_item: {
    uk: 'Позиція меню',
    en: 'Menu item',
    es: 'Ítem del menú',
    ru: 'Пункт меню',
  },
  inventory: {
    uk: 'Інвентаризація',
    en: 'Inventory',
    es: 'Inventario',
    ru: 'Инвентаризация',
  },
  residues: {
    uk: 'Залишки',
    en: 'Residues',
    es: 'Residuos',
    ru: 'Остатки',
  },
  all_stores: {
    uk: 'Всі склади',
    en: 'All storages',
    es: 'Todos los almacenes',
    ru: 'Все склады',
  },
  residues_in_all_stores: {
    uk: 'Залишки по всім складам',
    en: 'Residues in all storages',
    es: 'Residuos en todos los almacenes',
    ru: 'Остатки по всем складам',
  },
  and: {
    uk: 'та',
    en: 'and',
    es: 'y',
    ru: 'и',
  },
  stock_inventory: {
    uk: 'Інвентаризація складу',
    en: 'Storage inventory',
    es: 'Inventario de almacenamiento',
    ru: 'Инвентаризация склада',
  },
  take_inventory: {
    uk: 'Провести інвентаризацію',
    en: 'Take inventory',
    es: 'Hacer inventario',
    ru: 'Провести инвентаризацию',
  },
  uncategorized: {
    uk: 'Без категорії',
    en: 'Uncategorized',
    es: 'Sin categoría',
    ru: 'Без категории',
  },
  display_packaging: {
    uk: 'Відображати фасовку',
    en: 'Display packaging',
    es: 'Mostrar empaquetado',
    ru: 'Отображать фасовку',
  },
  quantity: {
    uk: 'Кількість',
    en: 'Quantity',
    es: 'Cantidad',
    ru: 'Количество',
  },
  max_quantity: {
    uk: 'Макс. кількість',
    en: 'Max quantity',
    es: 'Cantidad máxima',
    ru: 'Макс. количество',
  },
  valid_quantity: {
    uk: 'Дійсна кількість',
    en: 'Valid quantity',
    es: 'Cantidad válida',
    ru: 'Действительное количество',
  },
  move: {
    uk: 'Перемістити',
    en: 'Move',
    es: 'Mover',
    ru: 'Переместить',
  },
  from_store: {
    uk: 'Зі складу',
    en: 'From storage',
    es: 'Del almacen',
    ru: 'Со склада',
  },
  to_store: {
    uk: 'На склад',
    en: 'To storage',
    es: 'Al almacen',
    ru: 'На склад',
  },
  available: {
    uk: 'В наявності',
    en: 'Available',
    es: 'Disponible',
    ru: 'В наличии',
  },
  finances: {
    uk: 'Фінанси',
    en: 'Finances',
    es: 'Finanzas',
    ru: 'Финансы',
  },
  balance: {
    uk: 'Баланс',
    en: 'Balance',
    es: 'Balance',
    ru: 'Баланс',
  },
  salary: {
    uk: 'Заробітна плата',
    en: 'Salary',
    es: 'Salario',
    ru: 'Заработная плата',
  },
  restaurant: {
    uk: 'Ресторан',
    en: 'Restaurant',
    es: 'Restaurante',
    ru: 'Ресторан',
  },
  role: {
    uk: 'Роль',
    en: 'Role',
    es: 'Rol',
    ru: 'Роль',
  },
  role_and_permissions: {
    uk: 'Роль і права доступу',
    en: 'Role and permissions',
    es: 'Rol y permisos',
    ru: 'Роль и права доступа',
  },
  owner: {
    uk: 'Керівник',
    en: 'Manager',
    es: 'Gerente',
    ru: 'Управляющий',
  },
  admin: {
    uk: 'Адмін',
    en: 'Admin',
    es: 'Admin',
    ru: 'Админ',
  },
  waiter: {
    uk: 'Офіціант',
    en: 'Waiter',
    es: 'Camarero',
    ru: 'Официант',
  },
  cook: {
    uk: 'Кухар',
    en: 'Cook',
    es: 'Cocinero',
    ru: 'Повар',
  },
  bartender: {
    uk: 'Бармен',
    en: 'Bartender',
    es: 'Bartender',
    ru: 'Бармен',
  },
  other_role: {
    uk: 'Інше',
    en: 'Other',
    es: 'Otro',
    ru: 'Другое',
  },
  rate_per_hour: {
    uk: 'Ставка за годину',
    en: 'Rate per hour',
    es: 'Tarifa por hora',
    ru: 'Ставка за час',
  },
  percentage_of_sales: {
    uk: 'Відсоток від власних продажів',
    en: 'Percentage of own sales',
    es: 'Porcentaje de ventas propias',
    ru: 'Процент от собственных продаж',
  },
  phone: {
    uk: 'Телефон',
    en: 'Phone',
    es: 'Teléfono',
    ru: 'Телефон',
  },
  email: {
    uk: 'Email',
    en: 'Email',
    es: 'Email',
    ru: 'Электронная почта',
  },
  pos_terminal: {
    uk: 'POS термінал',
    en: 'POS terminal',
    es: 'TPV',
    ru: 'POS терминал',
  },
  you: {
    uk: 'Ви',
    en: 'You',
    es: 'Tú',
    ru: 'Вы',
  },
  history: {
    uk: 'Історія',
    en: 'History',
    es: 'Historia',
    ru: 'История',
  },
  operation: {
    uk: 'Операція',
    en: 'Operation',
    es: 'Operación',
    ru: 'Операция',
  },
  hidden: {
    uk: 'Прихований',
    en: 'Hidden',
    es: 'Oculto',
    ru: 'Скрытый',
  },
  income: {
    uk: 'Дохід',
    en: 'Income',
    es: 'Ingreso',
    ru: 'Доход',
  },
  add_income: {
    uk: 'Дадати дохід',
    en: 'Add income',
    es: 'Añadir ingreso',
    ru: 'Добавить доход',
  },
  spending: {
    uk: 'Витрата',
    en: 'Spending',
    es: 'Gasto',
    ru: 'Расход',
  },
  add_spending: {
    uk: 'Дадати витрату',
    en: 'Add a spending',
    es: 'Añadir gasto',
    ru: 'Добавить расход',
  },
  transfer: {
    uk: 'Переказ',
    en: 'Transfer',
    es: 'Transferir',
    ru: 'Перевод',
  },
  amount: {
    uk: 'Сума',
    en: 'Amount',
    es: 'Cantidad',
    ru: 'Сумма',
  },
  comment: {
    uk: 'Коментар',
    en: 'Comment',
    es: 'Comentario',
    ru: 'Комментарий',
  },
  add_comment: {
    uk: 'Додати коментар',
    en: 'Add a comment',
    es: 'Agregar un comentario',
    ru: 'Добавить комментарий',
  },
  comment_for_order: {
    uk: 'Коментар до замовлення',
    en: 'Comment for the order',
    es: 'Comentario para el pedido',
    ru: 'Комментарий к заказу',
  },
  date: {
    uk: 'Дата',
    en: 'Date',
    es: 'Fecha',
    ru: 'Дата',
  },
  author: {
    uk: 'Автор',
    en: 'Author',
    es: 'Autor',
    ru: 'Автор',
  },
  total: {
    uk: 'Всього',
    en: 'Total',
    es: 'Total',
    ru: 'Всего',
  },
  award_fine: {
    uk: 'Премія / Штраф',
    en: 'Award / Penalty',
    es: 'Premio / Multa',
    ru: 'Премия / Штраф',
  },
  start_time: {
    uk: 'Час початку',
    en: 'Start time',
    es: 'Hora de inicio',
    ru: 'Время начала',
  },
  time: {
    uk: 'Час',
    en: 'Time',
    es: 'Hora',
    ru: 'Время',
  },
  end_time: {
    uk: 'Час закінчення',
    en: 'End time',
    es: 'Hora de finalización',
    ru: 'Время окончания',
  },
  shift_duration: {
    uk: 'Тривалість зміни',
    en: 'Shift duration',
    es: 'Duración del turno',
    ru: 'Продолжительность смены',
  },
  h: {
    uk: 'год.',
    en: 'h',
    es: 'h',
    ru: 'ч',
  },
  m: {
    uk: 'хв.',
    en: 'm',
    es: 'm',
    ru: 'мин',
  },
  duplicate: {
    uk: 'Дублювати',
    en: 'Duplicate',
    es: 'Duplicar',
    ru: 'Дублировать',
  },
  on_certain_day: {
    uk: 'На певний день',
    en: 'On a certain day',
    es: 'En un día determinado',
    ru: 'На определенный день',
  },
  every_n_days: {
    uk: 'До кінця місяця через кожні n днів',
    en: 'Every n days until the end of the month',
    es: 'Cada n días hasta el final del mes',
    ru: 'Каждые n дней до конца месяца',
  },
  after_every: {
    uk: 'Через кожні',
    en: 'After every',
    es: 'Después de cada',
    ru: 'Через каждые',
  },
  on_certain_days_of_the_week: {
    uk: 'До кінця місяця в певні дні тижня',
    en: 'Until the end of the month on certain days of the week',
    es: 'Hasta el final del mes en ciertos días de la semana',
    ru: 'До конца месяца в определенные дни недели',
  },
  days: {
    uk: 'дн',
    en: 'd',
    es: 'd',
    ru: 'дн',
  },
  save_shift_error_message: {
    uk: 'Зміна не збережена! У цього працівника вже є зміна на цю дату.',
    en: 'The shift is not saved! This employee already has a shift on this date.',
    es: '¡El turno no se guarda! Este empleado ya tiene un turno en esta fecha.',
    ru: 'Смена не сохранена! У этого сотрудника уже есть смена на эту дату.',
  },
  edit_table_map: {
    uk: 'Карта столів',
    en: 'Map of tables',
    es: 'Mapa de mesas',
    ru: 'Карта столов',
  },
  edit_tables_map: {
    uk: 'Редагувати карту столів',
    en: 'Edit table map',
    es: 'Editar mapa de mesas',
    ru: 'Редактировать карту столов',
  },
  add_table: {
    uk: 'Додати стіл',
    en: 'Add a table',
    es: 'Agregar una mesa',
    ru: 'Добавить стол',
  },
  table: {
    uk: 'Стіл',
    en: 'Table',
    es: 'Mesa',
    ru: 'Стол',
  },
  tableName: {
    uk: 'Стіл',
    en: 'Table',
    es: 'Nombre de la mesa',
    ru: 'Название стола',
  },
  square: {
    uk: 'Квадратний',
    en: 'Square',
    es: 'Cuadrado',
    ru: 'Квадратный',
  },
  circle: {
    uk: 'Круглий',
    en: 'Сircular',
    es: 'Circular',
    ru: 'Круглый',
  },
  rectangleH: {
    uk: 'Прямокутний Горизонтальний',
    en: 'Rectangular Horizontal',
    es: 'Rectangular Horizontal',
    ru: 'Прямоугольный Горизонтальный',
  },
  rectangleV: {
    uk: 'Прямокутний Вертикальний',
    en: 'Rectangular Vertical',
    es: 'Rectangular Vertical',
    ru: 'Прямоугольный Вертикальный',
  },
  barV: {
    uk: 'Бар Вертикальний',
    en: 'Bar Vertical',
    es: 'Barra Vertical',
    ru: 'Бар Вертикальный',
  },
  barH: {
    uk: 'Бар Горизонтальний',
    en: 'Bar Horizontal',
    es: 'Barra Horizontal',
    ru: 'Бар Горизонтальный',
  },
  upload_background: {
    uk: 'Завантажити фон',
    en: 'Upload background',
    es: 'Cargar fondo',
    ru: 'Загрузить фон',
  },
  remove_background: {
    uk: 'Видалити фон',
    en: 'Remove background',
    es: 'Eliminar fondo',
    ru: 'Удалить фон',
  },
  new_order: {
    uk: 'Нове замовлення',
    en: 'New order',
    es: 'Nueva orden',
    ru: 'Новый заказ',
  },
  order: {
    uk: 'Замовлення',
    en: 'Order',
    es: 'Orden',
    ru: 'Заказ',
  },
  cooking_place: {
    uk: 'Місце приготування',
    en: 'Cooking place',
    es: 'Lugar de cocción',
    ru: 'Место приготовления',
  },
  add_cooking_place: {
    uk: 'Додати місце приготування',
    en: 'Add a сooking place',
    es: 'Agregar un lugar de cocinar',
    ru: 'Добавить место приготовления',
  },
  variations: {
    uk: 'Варіації',
    en: 'Variations',
    es: 'Variaciones',
    ru: 'Вариации',
  },
  variation: {
    uk: 'Варіація',
    en: 'Variation',
    es: 'Variación',
    ru: 'Вариация',
  },
  add_variation: {
    uk: 'Додати варіацію',
    en: 'Add a variation',
    es: 'Agregar una variación',
    ru: 'Добавить вариацию',
  },
  name_of_variation: {
    uk: 'Назва варіації',
    en: 'Name of the variation',
    es: 'Nombre de la variación',
    ru: 'Название вариации',
  },
  сhoose_variation: {
    uk: 'Оберіть варіацію',
    en: 'Choose a variation',
    es: 'Elegir una variación',
    ru: 'Выберите вариацию',
  },
  modifications: {
    uk: 'Модифікації',
    en: 'Modifications',
    es: 'Modificaciones',
    ru: 'Модификации',
  },
  add_modification: {
    uk: 'Додати модифікацію',
    en: 'Add a modification',
    es: 'Agregar una modificación',
    ru: 'Добавить модификацию',
  },
  name_of_modification: {
    uk: 'Назва модицікації',
    en: 'Name of the modification',
    es: 'Nombre de la modificación',
    ru: 'Название модификации',
  },
  no_items_in_order: {
    uk: 'В цьому замовленні ще не має позицій',
    en: 'There are no items in this order yet',
    es: 'Todavía no hay elementos en este pedido',
    ru: 'В этом заказе еще нет позиций',
  },
  queue: {
    uk: 'Черга',
    en: 'Queue',
    es: 'Cola',
    ru: 'Очередь',
  },
  status: {
    uk: 'Статус',
    en: 'Status',
    es: 'Estado',
    ru: 'Статус',
  },
  status_new: {
    uk: 'Додано',
    en: 'Added',
    es: 'Añadido',
    ru: 'Добавлено',
  },
  status_ordered: {
    uk: 'В очікуванні',
    en: 'Waiting',
    es: 'Esperando',
    ru: 'В ожидании',
  },
  status_processing: {
    uk: 'Приготування',
    en: 'Cooking',
    es: 'Cocinando',
    ru: 'Приготовление',
  },
  status_delivering: {
    uk: 'Доставляється',
    en: 'Being Delivered',
    es: 'En proceso de entrega',
    ru: 'Доставляется',
  },
  status_ready: {
    uk: 'Готово до подачі',
    en: 'Ready to serve',
    es: 'Listo para servir',
    ru: 'Готово к подаче',
  },
  status_complete: {
    uk: 'Подано',
    en: 'Served',
    es: 'Servido',
    ru: 'Подано',
  },
  split_order: {
    uk: 'Розділити замовлення',
    en: 'Split the order',
    es: 'Dividir el pedido',
    ru: 'Разделить заказ',
  },
  pay: {
    uk: 'Сплатити',
    en: 'Pay',
    es: 'Pagar',
    ru: 'Оплатить',
  },
  print_bill: {
    uk: 'Друкувати рахунок',
    en: 'Print bill',
    es: 'Imprimir factura',
    ru: 'Печать счета',
  },
  view_bill: {
    uk: 'Переглянути рахунок',
    en: 'View bill',
    es: 'Ver factura',
    ru: 'Просмотр счета',
  },
  сhange_waiter_or_table: {
    uk: 'Зміна офіціанта або столика',
    en: 'Change waiter or table',
    es: 'Cambiar el camarero o la mesa',
    ru: 'Смена официанта или столика',
  },
  cash: {
    uk: 'Готівка',
    en: 'Cash',
    es: 'Efectivo',
    ru: 'Наличные',
  },
  in_cash: {
    uk: 'Готівкою',
    en: 'In cash',
    es: 'En efectivo',
    ru: 'Наличными',
  },
  rest: {
    uk: 'Решта',
    en: 'Rest',
    es: 'Resto',
    ru: 'Сдача',
  },
  to_pay: {
    uk: 'До сплати',
    en: 'To pay',
    es: 'A pagar',
    ru: 'К оплате',
  },
  by_card: {
    uk: 'Карткою',
    en: 'By card',
    es: 'Con tarjeta',
    ru: 'Картой',
  },
  card: {
    uk: 'Картка',
    en: 'Card',
    es: 'Tarjeta',
    ru: 'Карта',
  },
  paid: {
    uk: 'Сплачено',
    en: 'Paid',
    es: 'Pagado',
    ru: 'Оплачено',
  },
  use_for_cash_orders: {
    uk: 'Використовувати для готівкового розрахунку замовлень',
    en: 'Use for cash orders',
    es: 'Usar para pedidos en efectivo',
    ru: 'Использовать для наличного расчета заказов',
  },
  use_for_card_orders: {
    uk: 'Використовувати для безготівкового розрахунку замовлень',
    en: 'Use for card orders',
    es: 'Usar para pedidos con tarjeta',
    ru: 'Использовать для безналичного расчета заказов',
  },
  kitchen_screen: {
    uk: 'Екран кухні',
    en: 'Kitchen screen',
    es: 'Pantalla de cocina',
    ru: 'Экран кухни',
  },
  display_progress_bar: {
    uk: 'Відображати шкалу прогресу',
    en: 'Display progress bar',
    es: 'Mostrar barra de progreso',
    ru: 'Отображать шкалу прогресса',
  },
  display_additional_info: {
    uk: 'Відображати додаткову інформацію',
    en: 'Display additional information',
    es: 'Mostrar información adicional',
    ru: 'Отображать дополнительную информацию',
  },
  info: {
    uk: 'Інфо',
    en: 'Info',
    es: 'Info',
    ru: 'Инфо',
  },
  prepare_semifinished_product: {
    uk: 'Виготовити напівфабрикат',
    en: 'Prepare semifinished product',
    es: 'Preparar producto semiacabado',
    ru: 'Изготовить полуфабрикат',
  },
  make_semifinished_product: {
    uk: 'Виготовити напівфабрикат',
    en: 'Make semifinished product',
    es: 'Hacer producto semiacabado',
    ru: 'Сделать полуфабрикат',
  },
  min_ago: {
    uk: 'хв тому',
    en: 'min ago',
    es: 'min hace',
    ru: 'мин назад',
  },
  total_in_stock: {
    uk: 'Всього на складі',
    en: 'Total in stock',
    es: 'Total en stock',
    ru: 'Всего на складе',
  },
  variation_set: {
    uk: 'набір варіацій',
    en: 'variation set',
    es: 'conjunto de variaciones',
    ru: 'набор вариаций',
  },
  order_archive: {
    uk: 'Архів замовлень',
    en: 'Order archive',
    es: 'Archivo de pedidos',
    ru: 'Архив заказов',
  },
  creation_time: {
    uk: 'Час створення',
    en: 'Creation time',
    es: 'Hora de creación',
    ru: 'Время создания',
  },
  number: {
    uk: 'Номер',
    en: 'Number',
    es: 'Número',
    ru: 'Номер',
  },
  not_closed: {
    uk: 'Не закрите',
    en: 'Not closed',
    es: 'No cerrado',
    ru: 'Не закрыто',
  },
  supply: {
    uk: 'Постачання',
    en: 'Supply',
    es: 'Suministro',
    ru: 'Поставка',
  },
  create_supply: {
    uk: 'Створити поставку',
    en: 'Create supply',
    es: 'Crear suministro',
    ru: 'Создать поставку',
  },
  in_progress: {
    uk: 'В процесі',
    en: 'In progress',
    es: 'En progreso',
    ru: 'В процессе',
  },
  accepted: {
    uk: 'Прийнято',
    en: 'Accepted',
    es: 'Aceptado',
    ru: 'Принято',
  },
  cancelled: {
    uk: 'Відмінено',
    en: 'Cancelled',
    es: 'Cancelado',
    ru: 'Отменено',
  },
  accept_supply: {
    uk: 'Прийняти поставку',
    en: 'Accept supply',
    es: 'Aceptar suministro',
    ru: 'Принять поставку',
  },
  accept: {
    uk: 'Прийняти',
    en: 'Accept',
    es: 'Aceptar',
    ru: 'Принять',
  },
  print: {
    uk: 'Друкувати',
    en: 'Print',
    es: 'Imprimir',
    ru: 'Печатать',
  },
  iva: {
    uk: 'ПДВ',
    en: 'IVA',
    es: 'IVA',
    ru: 'НДС',
  },
  no_shift: {
    uk: 'На даний момент у Вас немає робочої зміни',
    en: 'You do not have an active shift at the moment',
    es: 'Actualmente no tienes un turno activo',
    ru: 'На данный момент у Вас нет рабочей смены',
  },
  hours: {
    uk: 'Години',
    en: 'Hours',
    es: 'Horas',
    ru: 'Часы',
  },
  rate: {
    uk: 'Ставка',
    en: 'Rate',
    es: 'Tarifa',
    ru: 'Ставка',
  },
  commission_for_own_sales: {
    uk: 'Нарахування за власні продажі',
    en: 'Commission for own sales',
    es: 'Comisión por ventas propias',
    ru: 'Начисления за собственные продажи',
  },
  unpaid: {
    uk: 'Не сплачено',
    en: 'Unpaid',
    es: 'Impago',
    ru: 'Не оплачено',
  },
  conduct_payment: {
    uk: 'Провести виплату',
    en: 'Conduct payment',
    es: 'Realizar pago',
    ru: 'Провести выплату',
  },
  unclosed_orders: {
    uk: 'Є незакриті замовлення',
    en: 'There are unclosed orders',
    es: 'Hay pedidos sin cerrar',
    ru: 'Есть незакрытые заказы',
  },
  deduct_from_wallet: {
    uk: 'Списати з рахунку',
    en: 'Deduct from wallet',
    es: 'Descontar del monedero',
    ru: 'Списать с счета',
  },
  deduct_product_cost_from_bill: {
    uk: 'Списати вартість продуктів з рахунку',
    en: 'Deduct Product Cost from Bill',
    es: 'Deducir el Costo de los Productos de la Factura',
    ru: 'Списать стоимость продуктов с счета',
  },
  salary_payment: {
    uk: 'Виплата заробітної плати',
    en: 'Salary payment',
    es: 'Pago de salario',
    ru: 'Выплата заработной платы',
  },
  transfer_from_wallet: {
    uk: 'Переказ з рахунку',
    en: 'Transfer from wallet',
    es: 'Transferencia desde el monedero',
    ru: 'Перевод со счета',
  },
  transfer_to_wallet: {
    uk: 'Переказ на рахунок',
    en: 'Transfer to wallet',
    es: 'Transferencia al monedero',
    ru: 'Перевод на счет',
  },
  added_to_order: {
    uk: 'додано до замовлення',
    en: 'added to order',
    es: 'añadido al pedido',
    ru: 'добавлено к заказу',
  },
  removed_from_order: {
    uk: 'видалено з замовлення',
    en: 'removed from order',
    es: 'eliminado del pedido',
    ru: 'удалено из заказа',
  },
  semifinished_product_made: {
    uk: 'Виготовлено напівфабрикат',
    en: 'Semifinished product made',
    es: 'Napílfabricado hecho',
    ru: 'Полуфабрикат изготовлен',
  },
  moved_from: {
    uk: 'Переміщено з',
    en: 'Moved from',
    es: 'Movido de',
    ru: 'Перемещено с',
  },
  to: {
    uk: 'до',
    en: 'to',
    es: 'a',
    ru: 'на',
  },
  after: {
    uk: 'Після',
    en: 'After',
    es: 'Después de',
    ru: 'После',
  },
  before: {
    uk: 'До',
    en: 'Before',
    es: 'Antes',
    ru: 'До',
  },
  difference: {
    uk: 'Різниця',
    en: 'Difference',
    es: 'Diferencia',
    ru: 'Разница',
  },
  modified: {
    uk: 'Змінено',
    en: 'Modified',
    es: 'Modificado',
    ru: 'Изменено',
  },
  modified_table_or_waiter: {
    uk: 'Змінено стіл або офіціанта',
    en: 'Modified table or waiter',
    es: 'Mesa o camarero modificado',
    ru: 'Изменен стол или официант',
  },
  order_created: {
    uk: 'Створено замовлення',
    en: 'Order created',
    es: 'Orden creada',
    ru: 'Заказ создан',
  },
  bill_printed: {
    uk: 'Роздруковано рахунок',
    en: 'Bill printed',
    es: 'Factura impresa',
    ru: 'Счет распечатан',
  },
  order_split: {
    uk: 'Замовлення розділено',
    en: 'Order split',
    es: 'Orden dividida',
    ru: 'Заказ разделен',
  },
  processing: {
    uk: 'Процесинг',
    en: 'Processing',
    es: 'Procesando',
    ru: 'Обработка',
  },
  bill: {
    uk: 'Рахунок',
    en: 'Bill',
    es: 'Factura',
    ru: 'Счет',
  },
  table_map: {
    uk: 'Карта столів',
    en: 'Table map',
    es: 'Mapa de mesas',
    ru: 'Карта столов',
  },
  use_table_map: {
    uk: 'Використовувати карту столів',
    en: 'Use table map',
    es: 'Usar mapa de mesas',
    ru: 'Использовать карту столов',
  },
  order_statuses: {
    uk: 'Статуси замовлень',
    en: 'Order statuses',
    es: 'Estados de la orden',
    ru: 'Статусы заказов',
  },
  order_status_changed: {
    uk: 'Змінено статус замовлення',
    en: 'Order status changed',
    es: 'Estado del pedido cambiado',
    ru: 'Статус заказа изменен',
  },
  delivery_info_changed: {
    uk: 'Змінено інформацію про доставку',
    en: 'Delivery information changed',
    es: 'Información de entrega modificada',
    ru: 'Информация о доставке изменена',
  },
  all_statuses: {
    uk: 'Всі статуси',
    en: 'All statuses',
    es: 'Todos los estados',
    ru: 'Все статусы',
  },
  waiter_statuses_only: {
    uk: 'Тільки статуси офіціантів',
    en: 'Waiter statuses only',
    es: 'Solo estados de camarero',
    ru: 'Только статусы официантов',
  },
  without_statuses: {
    uk: 'Без статусів',
    en: 'Without statuses',
    es: 'Sin estados',
    ru: 'Без статусов',
  },
  paper_width: {
    uk: 'Ширина паперу',
    en: 'Paper width',
    es: 'Ancho del papel',
    ru: 'Ширина бумаги',
  },
  mm: {
    uk: 'мм',
    en: 'mm',
    es: 'mm',
    ru: 'мм',
  },
  restaurant_logo: {
    uk: 'Лого ресторану',
    en: 'Restaurant logo',
    es: 'Logo del restaurante',
    ru: 'Логотип ресторана',
  },
  initial_text: {
    uk: 'Початковий текст',
    en: 'Initial text',
    es: 'Texto inicial',
    ru: 'Начальный текст',
  },
  title: {
    uk: 'Заголовок',
    en: 'Title',
    es: 'Título',
    ru: 'Заголовок',
  },
  final_text: {
    uk: 'Кінцевий текст',
    en: 'Final text',
    es: 'Texto final',
    ru: 'Конечный текст',
  },
  tax_line: {
    uk: 'Строка податків',
    en: 'Tax line',
    es: 'Línea de impuestos',
    ru: 'Строка налогов',
  },
  tax_name: {
    uk: 'Назва податку',
    en: 'Tax name',
    es: 'Nombre de impuesto',
    ru: 'Название налога',
  },
  percentage: {
    uk: 'Відсоток',
    en: 'Percentage',
    es: 'Porcentaje',
    ru: 'Процент',
  },
  create_and_edit_own_orders: {
    uk: 'Створювати та редагувати власні замовлення',
    en: 'Create and edit own orders',
    es: 'Crear y editar órdenes propias',
    ru: 'Создавать и редактировать собственные заказы',
  },
  view_orders_of_other_employees: {
    uk: 'Бачити замовлення інших працівників',
    en: 'View orders of other employees',
    es: 'Ver órdenes de otros empleados',
    ru: 'Видеть заказы других сотрудников',
  },
  edit_orders_of_other_employees: {
    uk: 'Редагувати замовлення інших працівників',
    en: 'Edit orders of other employees',
    es: 'Editar órdenes de otros empleados',
    ru: 'Редактировать заказы других сотрудников',
  },
  access_denied: {
    uk: 'Ви не маєте доступу до цьєї сторінки',
    en: 'You do not have access to this page',
    es: 'No tiene acceso a esta página',
    ru: 'У вас нет доступа к этой странице',
  },
  menu_and_product_settings: {
    uk: 'Налаштування меню та продуктів',
    en: 'Menu and product settings',
    es: 'Configuración de menú y productos',
    ru: 'Настройки меню и продуктов',
  },
  restaurant_settings: {
    uk: 'Налаштування ресторану',
    en: 'Restaurant settings',
    es: 'Configuración del restaurante',
    ru: 'Настройки ресторана',
  },
  change_order_statuses: {
    uk: 'Змінювати статуси замовлень',
    en: 'Change order statuses',
    es: 'Cambiar estados de la orden',
    ru: 'Изменять статусы заказов',
  },
  make_semifinished_products: {
    uk: 'Виготовляти напівфабрикати',
    en: 'Make semifinished products',
    es: 'Hacer productos semiterminados',
    ru: 'Изготавливать полуфабрикаты',
  },
  view_archive_of_other_employees: {
    uk: 'Бачити архів інших працівників',
    en: 'View archive of other employees',
    es: 'Ver el archivo de otros empleados',
    ru: 'Видеть архив других сотрудников',
  },
  conduct_inventory: {
    uk: 'Проводити інвентаризацію',
    en: 'Conduct inventory',
    es: 'Realizar inventario',
    ru: 'Проводить инвентаризацию',
  },
  edit_stores: {
    uk: 'Редагувати склади',
    en: 'Edit storages',
    es: 'Editar almacenes',
    ru: 'Редактировать склады',
  },
  create_supplies: {
    uk: 'Створювати поставки',
    en: 'Create supplies',
    es: 'Crear suministros',
    ru: 'Создавать поставки',
  },
  edit_supplies: {
    uk: 'Редагувати поставки',
    en: 'Edit supplies',
    es: 'Editar suministros',
    ru: 'Редактировать поставки',
  },
  accept_supplies: {
    uk: 'Приймати поставки',
    en: 'Accept supplies',
    es: 'Aceptar suministros',
    ru: 'Принимать поставки',
  },
  view_work_shifts_of_other_employees: {
    uk: 'Бачити робочі зміни інших працівників',
    en: 'View work shifts of other employees',
    es: 'Ver los turnos de trabajo de otros empleados',
    ru: 'Видеть рабочие смены других сотрудников',
  },
  edit_own_work_shifts: {
    uk: 'Редагувати власні робочі зміни',
    en: 'Edit own work shifts',
    es: 'Editar sus propios turnos de trabajo',
    ru: 'Редактировать свои рабочие смены',
  },
  edit_work_shifts_of_other_employees: {
    uk: 'Редагувати робочі зміни інших працівників',
    en: 'Edit work shifts of other employees',
    es: 'Editar los turnos de trabajo de otros empleados',
    ru: 'Редактировать рабочие смены других сотрудников',
  },
  view_hidden_wallets: {
    uk: 'Бачити приховані рахунки',
    en: 'View hidden wallets',
    es: 'Ver billeteras ocultas',
    ru: 'Видеть скрытые счета',
  },
  perform_operations_with_wallets: {
    uk: 'Проводити операції з рахунками',
    en: 'Perform operations with wallets',
    es: 'Realizar operaciones con billeteras',
    ru: 'Проводить операции со счетами',
  },
  cancel_operations_with_wallets: {
    uk: 'Скасовувати операції з рахунками',
    en: 'Cancel operations with wallets',
    es: 'Cancelar operaciones con billeteras',
    ru: 'Отменять операции со счетами',
  },
  edit_wallets: {
    uk: 'Редагувати рахунки',
    en: 'Edit wallets',
    es: 'Editar billeteras',
    ru: 'Редактировать счета',
  },
  view_other_employees_salary: {
    uk: 'Бачити заробітню плату інших співробітників',
    en: 'View salary of other employees',
    es: 'Ver el salario de otros empleados',
    ru: 'Видеть зарплату других сотрудников',
  },
  perform_salary_payments: {
    uk: 'Проводити виплати заробітної плату',
    en: 'Perform salary payments',
    es: 'Realizar pagos de salario',
    ru: 'Проводить выплаты зарплаты',
  },
  access_without_shift: {
    uk: 'Доступ до системи без робочої зміни',
    en: 'Access without shift',
    es: 'Acceso sin turno de trabajo',
    ru: 'Доступ без смены',
  },
  allow_create_shift_on_login: {
    uk: 'Дозволити створювати зміну при вході в систему',
    en: 'Allow creating a shift on login',
    es: 'Permitir crear un turno al iniciar sesión',
    ru: 'Разрешить создавать смену при входе',
  },
  my_restaurants: {
    uk: 'Мої ресторани',
    en: 'My restaurants',
    es: 'Mis restaurantes',
    ru: 'Мои рестораны',
  },
  pin_code_for_multiuser_terminal: {
    uk: 'Пін-код для мультикористувацького термінала',
    en: 'PIN code for multi-user terminal',
    es: 'Código PIN para terminal multiusuario',
    ru: 'Пин-код для мультипользовательского терминала',
  },
  multiuser_terminal: {
    uk: 'Мультикористувацький термінал',
    en: 'Multi-user terminal',
    es: 'Terminal multiusuario',
    ru: 'Мультипользовательский терминал',
  },
  use_this_device_as_multiuser_terminal: {
    uk: 'Використовувати цей пристрій як мультикористувацький термінал',
    en: 'Use this device as a multi-user terminal',
    es: 'Usar este dispositivo como terminal multiusuario',
    ru: 'Использовать это устройство как мультипользовательский терминал',
  },
  turn_on: {
    uk: 'Увімкнути',
    en: 'Turn on',
    es: 'Encender',
    ru: 'Включить',
  },
  check_pin_codes: {
    uk: 'Перед тим, як увімкнути мультикористувальний термінал, переконайтеся, що у співробітників вказані пінкоди для мультикористувацького терміналу',
    en: 'Before turning on the multi-user terminal, make sure that the employees have set their PIN codes for the multi-user terminal',
    es: 'Antes de encender el terminal multiusuario, asegúrese de que los empleados hayan configurado sus códigos PIN para el terminal multiusuario',
    ru: 'Перед тем как включить мультипользовательский терминал, убедитесь, что у сотрудников указаны пин-коды для мультипользовательского терминала',
  },
  enter_pin: {
    uk: 'Введіть пін-код',
    en: 'Enter PIN-code',
    es: 'Ingrese el código PIN',
    ru: 'Введите пин-код',
  },
  pin: {
    uk: 'Пін-код',
    en: 'PIN-code',
    es: 'Código PIN',
    ru: 'Пин-код',
  },
  disable_multi_user: {
    uk: 'Вимкнути мультикористувальний термінал',
    en: 'Disable multi-user terminal',
    es: 'Desactivar el terminal multiusuario',
    ru: 'Отключить мультипользовательский терминал',
  },
  confirm_disable_multi_user_mode: {
    uk: 'Ви впевнені, що бажаєте вимкнути мультикористувацький режим для цього пристрою?',
    en: 'Are you sure you want to disable multi-user mode for this device?',
    es: '¿Está seguro de que desea desactivar el modo multiusuario para este dispositivo?',
    ru: 'Вы уверены, что хотите отключить мультипользовательский режим для этого устройства?',
  },
  removed: {
    uk: 'Видалено',
    en: 'Removed',
    es: 'Eliminado',
    ru: 'Удалено',
  },
  created: {
    uk: 'Створено',
    en: 'Created',
    es: 'Creado',
    ru: 'Создано',
  },
  today_shifts: {
    uk: 'Робочі зміни на сьогодні',
    en: `Today's shifts`,
    es: 'Turnos de hoy',
    ru: 'Смены на сегодня',
  },
  today_is_weekend: {
    uk: 'Здається, сьогодні вихідний',
    en: "Looks like it's a weekend today",
    es: 'Parece que hoy es fin de semana',
    ru: 'Похоже, сегодня выходной',
  },
  revenue: {
    uk: 'Дохід',
    en: 'Revenue',
    es: 'Ingresos',
    ru: 'Доход',
  },
  day: {
    uk: 'День',
    en: 'Day',
    es: 'Día',
    ru: 'День',
  },
  week: {
    uk: 'Тиждень',
    en: 'Week',
    es: 'Semana',
    ru: 'Неделя',
  },
  sales: {
    uk: 'Продажі',
    en: 'Sales',
    es: 'Ventas',
    ru: 'Продажи',
  },
  current_period: {
    uk: 'Поточний період',
    en: 'Current period',
    es: 'Período actual',
    ru: 'Текущий период',
  },
  last_week: {
    uk: 'Минулого тижня',
    en: 'Last week',
    es: 'La semana pasada',
    ru: 'Прошлая неделя',
  },
  step: {
    uk: 'Крок',
    en: 'Step',
    es: 'Paso',
    ru: 'Шаг',
  },
  done: {
    uk: 'Готово',
    en: 'Done',
    es: 'Hecho',
    ru: 'Готово',
  },
  background_image: {
    uk: 'Фонове зображення',
    en: 'Background Image',
    es: 'Imagen de fondo',
    ru: 'Фоновое изображение',
  },
  copied: {
    uk: 'Cкопійовано',
    en: 'Copied',
    es: 'Copiado',
    ru: 'Скопировано',
  },
  instagram_link: {
    uk: 'Посилання на Instagram',
    en: 'Instagram Link',
    es: 'Enlace de Instagram',
    ru: 'Ссылка на Instagram',
  },
  facebook_link: {
    uk: 'Посилання на Facebook',
    en: 'Facebook Link',
    es: 'Enlace de Facebook',
    ru: 'Ссылка на Facebook',
  },
  online_menu_link: {
    uk: 'Посилання на онлайн меню',
    en: 'Online Menu Link',
    es: 'Enlace al menú en línea',
    ru: 'Ссылка на онлайн меню',
  },
  download: {
    uk: 'Завантажити',
    en: 'Download',
    es: 'Descargar',
    ru: 'Скачать',
  },
  address: {
    uk: 'Адреса',
    en: 'Address',
    es: 'Dirección',
    ru: 'Адрес',
  },
  volume: {
    uk: "Об'єм",
    en: 'Volume',
    es: 'Volumen',
    ru: 'Объем',
  },
  weight: {
    uk: 'Вага',
    en: 'Weight',
    es: 'Peso',
    ru: 'Вес',
  },
  celery: {
    uk: 'селера',
    en: 'celery',
    es: 'apio',
    ru: 'сельдерей',
  },
  crustacean: {
    uk: 'коропові',
    en: 'crustaceans',
    es: 'crustáceos',
    ru: 'ракообразные',
  },
  eggs: {
    uk: 'яйця',
    en: 'eggs',
    es: 'huevos',
    ru: 'яйца',
  },
  fish: {
    uk: 'риба',
    en: 'fish',
    es: 'pescado',
    ru: 'рыба',
  },
  gluten: {
    uk: 'глютен',
    en: 'gluten',
    es: 'gluten',
    ru: 'глютен',
  },
  lupins: {
    uk: 'люпин',
    en: 'lupins',
    es: 'altramuces',
    ru: 'люпин',
  },
  milk: {
    uk: 'молоко',
    en: 'milk',
    es: 'leche',
    ru: 'молоко',
  },
  mustard: {
    uk: 'гірчиця',
    en: 'mustard',
    es: 'mostaza',
    ru: 'горчица',
  },
  nuts: {
    uk: 'горіхи',
    en: 'nuts',
    es: 'frutos secos',
    ru: 'орехи',
  },
  peanuts: {
    uk: 'арахіс',
    en: 'peanuts',
    es: 'cacahuetes',
    ru: 'арахис',
  },
  sesame: {
    uk: 'кунжут',
    en: 'sesame',
    es: 'sésamo',
    ru: 'кунжут',
  },
  shellfish: {
    uk: 'морепродукти',
    en: 'shellfish',
    es: 'mariscos',
    ru: 'моллюски',
  },
  soya: {
    uk: 'соя',
    en: 'soya',
    es: 'soja',
    ru: 'соя',
  },
  sulphite: {
    uk: 'сульфіт',
    en: 'sulphite',
    es: 'sulfito',
    ru: 'сульфиты',
  },
  allergens: {
    uk: 'Алергени',
    en: 'Allergens',
    es: 'Alergenos',
    ru: 'Аллергены',
  },
  vegetarian: {
    uk: 'Вегетаріанське',
    en: 'Vegetarian',
    es: 'Vegetariano',
    ru: 'Вегетарианское',
  },
  spicy: {
    uk: 'Гостре',
    en: 'Spicy',
    es: 'Picante',
    ru: 'Острое',
  },
  closed: {
    uk: 'Зачинено',
    en: 'Closed',
    es: 'Cerrado',
    ru: 'Закрыто',
  },
  shift_closed: {
    uk: 'Закрито',
    en: 'Closed',
    es: 'Cerrado',
    ru: 'Закрыто',
  },
  works_with_break: {
    uk: 'Працює з перервою',
    en: 'Works with break',
    es: 'Trabaja con descanso',
    ru: 'Работает с перерывом',
  },
  working_hours: {
    uk: 'Години роботи',
    en: 'Working Hours',
    es: 'Horario de trabajo',
    ru: 'Часы работы',
  },
  online_table_booking: {
    uk: 'Бронювання столів онлайн',
    en: 'Online table booking',
    es: 'Reserva de mesa en línea',
    ru: 'Бронирование столов онлайн',
  },
  table_booking_widget_link: {
    uk: 'Посилання на віджет бронювання столів',
    en: 'Table booking widget link',
    es: 'Enlace del widget de reserva de mesa',
    ru: 'Ссылка на виджет бронирования столов',
  },
  booking: {
    uk: 'Бронювання столів',
    en: 'Table Booking',
    es: 'Reserva de Mesas',
    ru: 'Бронирование столов',
  },
  quantity_of_visitors: {
    uk: 'Кількість відвідувачів',
    en: 'Number of visitors',
    es: 'Número de visitantes',
    ru: 'Количество посетителей',
  },
  add_booking: {
    uk: 'Додати бронювання',
    en: 'Add Booking',
    es: 'Agregar Reserva',
    ru: 'Добавить бронирование',
  },
  table_reservation: {
    uk: 'Бронювання столу',
    en: 'Table Reservation',
    es: 'Reserva de mesa',
    ru: 'Бронирование стола',
  },
  all_bookings: {
    uk: 'Всі бронювання',
    en: 'All Bookings',
    es: 'Todas las Reservas',
    ru: 'Все бронирования',
  },
  unconfirmed_bookings: {
    uk: 'Непідтвердженні',
    en: 'Unconfirmed',
    es: 'No confirmadas',
    ru: 'Неподтвержденные',
  },
  booked: {
    uk: 'Заброньовано',
    en: 'Booked',
    es: 'Reservado',
    ru: 'Забронировано',
  },
  plan: {
    uk: 'План',
    en: 'Plan',
    es: 'Plan',
    ru: 'План',
  },
  current_plan: {
    uk: 'Діючий план',
    en: 'Current Plan',
    es: 'Plan Actual',
    ru: 'Действующий план',
  },
  free: {
    uk: 'Безкоштовно',
    en: 'Free',
    es: 'Gratis',
    ru: 'Бесплатно',
  },
  month: {
    uk: 'міс',
    en: 'month',
    es: 'mes',
    ru: 'мес',
  },
  year: {
    uk: 'рік',
    en: 'year',
    es: 'año',
    ru: 'год',
  },
  tariff_plans_details: {
    uk: 'Детальніше про тарифні плани: +38 097 682 98 56',
    en: 'More about tariff plans: +38 097 682 98 56',
    es: 'Más sobre los planes tarifarios: +38 097 682 98 56',
    ru: 'Подробнее о тарифных планах: +38 097 682 98 56',
  },
  switch_to: {
    uk: 'Перейти на',
    en: 'Switch to',
    es: 'Cambiar a',
    ru: 'Перейти на',
  },
  visitor_reviews: {
    uk: 'Відгуки відвідувачів',
    en: 'Visitor Reviews',
    es: 'Opiniones de los Visitantes',
    ru: 'Отзывы посетителей',
  },
  expected: {
    uk: 'Очікується',
    en: 'Expected',
    es: 'Esperado',
    ru: 'Ожидается',
  },
  order_through_qr_menu: {
    uk: 'Замовлення через QR Menu',
    en: 'Order through QR Menu',
    es: 'Pedido a través del Menú QR',
    ru: 'Заказ через QR меню',
  },
  try_for_free: {
    uk: 'Спробувати безкоштовно',
    en: 'Try for Free',
    es: 'Probar Gratis',
    ru: 'Попробовать бесплатно',
  },
  select: {
    uk: 'Обрати',
    en: 'Select',
    es: 'Seleccionar',
    ru: 'Выбрать',
  },
  valid_until: {
    uk: 'Дійсний до',
    en: 'Valid until',
    es: 'Válido hasta',
    ru: 'Действителен до',
  },
  dishes: {
    uk: 'Страви',
    en: 'Dishes',
    es: 'Platos',
    ru: 'Блюда',
  },
  service: {
    uk: 'Обслуговування',
    en: 'Service',
    es: 'Servicio',
    ru: 'Обслуживание',
  },
  atmosphere: {
    uk: 'Атмосфера',
    en: 'Atmosphere',
    es: 'Ambiente',
    ru: 'Атмосфера',
  },
  review: {
    uk: 'Відгук',
    en: 'Review',
    es: 'Reseña',
    ru: 'Отзыв',
  },
  agree_terms: {
    uk: 'Реєструючись, ви погоджуєтесь з:',
    en: 'By registering, you agree to:',
    es: 'Al registrarte, aceptas:',
    ru: 'Регистрируясь, вы соглашаетесь с:',
  },
  terms_and_conditions: {
    uk: 'правила та умови',
    en: 'terms and conditions',
    es: 'términos y condiciones',
    ru: 'правила и условия',
  },
  privacy_policy: {
    uk: 'політика конфіденційності',
    en: 'privacy policy',
    es: 'política de privacidad',
    ru: 'политика конфиденциальности',
  },
  cookie_policy: {
    uk: 'політика файлів cookie',
    en: 'cookie policy',
    es: 'política de cookies',
    ru: 'политика использования файлов cookie',
  },
  country: {
    uk: 'Країна',
    en: 'Country',
    es: 'País',
    ru: 'Страна',
  },
  bold_font: {
    uk: 'Жирний шрифт',
    en: 'Bold font',
    es: 'Fuente en negrita',
    ru: 'Жирный шрифт',
  },
  service_charge: {
    uk: 'За обслуговування',
    en: 'Service charge',
    es: 'Cargo por servicio',
    ru: 'За обслуживание',
  },
  max_discount: {
    uk: 'Максимальна скидка',
    en: 'Maximum discount',
    es: 'Descuento máximo',
    ru: 'Максимальная скидка',
  },
  discount: {
    uk: 'Знижка',
    en: 'Discount',
    es: 'Descuento',
    ru: 'Скидка',
  },
  change_service_discount_percentage: {
    uk: 'Змінювати відсоток за обслуговування',
    en: 'Change service charge',
    es: 'Cambiar el porcentaje de cargo por servicio',
    ru: 'Изменить процент за обслуживание',
  },
  qty: {
    uk: 'К-ть',
    en: 'Qty',
    es: '',
    ru: 'Кол-во',
  },
  sold_by_weight_volume: {
    uk: "Продається на вагу/об'єм",
    en: 'Sold by weight/volume',
    es: 'Se vende por peso/volumen',
    ru: 'Продаётся на вес/объем',
  },
  standard_portion: {
    uk: 'Стандартна порція',
    en: 'Standard portion',
    es: 'Porción estándar',
    ru: 'Стандартная порция',
  },
  portion: {
    uk: 'Порція',
    en: 'Portion',
    es: 'Porción',
    ru: 'Порция',
  },
  screenLockTimeRemaining: {
    uk: 'Час до блокування екрану',
    en: 'Time Until Screen Lock',
    es: 'Tiempo hasta el Bloqueo de Pantalla',
    ru: 'Время до блокировки экрана',
  },
  sec: {
    uk: 'сек',
    en: 'sec',
    es: 'seg',
    ru: 'сек',
  },
  reports: {
    uk: 'Звіти',
    en: 'Reports',
    es: 'Informes',
    ru: 'Отчеты',
  },
  cost: {
    uk: 'Вартість',
    en: 'Cost',
    es: 'Costo',
    ru: 'Стоимость',
  },
  in_restaurant: {
    uk: 'В закладі',
    en: 'In Restaurant',
    es: 'En el restaurante',
    ru: 'В заведении',
  },
  order_type_delivery: {
    uk: 'Доставка',
    en: 'Delivery',
    es: 'Entrega a domicilio',
    ru: 'Доставка',
  },
  order_type_selfOrder: {
    uk: 'В закладі (QR)',
    en: 'In Restaurant (QR)',
    es: 'En el restaurante (QR)',
    ru: 'В заведении (QR)',
  },
  order_type_regular: {
    uk: 'В закладі',
    en: 'In Restaurant',
    es: 'En el restaurante',
    ru: 'В заведении',
  },
  order_type_tableOrder: {
    uk: 'В закладі (QR)',
    en: 'In Restaurant (QR)',
    es: 'En el restaurante (QR)',
    ru: 'В заведении (QR)',
  },
  delivery: {
    uk: 'Доставка',
    en: 'Delivery',
    es: 'Entrega a domicilio',
    ru: 'Доставка',
  },
  qr_menu: {
    uk: 'QR Меню',
    en: 'QR Menu',
    es: 'Menú QR',
    ru: 'QR Меню',
  },
  ordering_and_payment: {
    uk: 'Замовлення та оплата через QR Меню',
    en: 'Ordering and Payment through QR Menu',
    es: 'Pedido y Pago a través del Menú QR',
    ru: 'Заказ и оплата через QR Меню',
  },
  close: {
    uk: 'Закрити',
    en: 'Close',
    es: 'Cerrar',
    ru: 'Закрыть',
  },
  customer: {
    uk: 'Замовник',
    en: 'Customer',
    es: 'Cliente',
    ru: 'Заказчик',
  },
  delivered: {
    uk: 'Доставлено',
    en: 'Delivered',
    es: 'Entregado',
    ru: 'Доставлено',
  },
  delivery_terms: {
    uk: 'Умови доставки',
    en: 'Delivery Terms',
    es: 'Términos de Entrega',
    ru: 'Условия доставки',
  },
  order_type: {
    uk: 'Тип замовлення',
    en: 'Order Type',
    es: 'Tipo de pedido',
    ru: 'Тип заказа',
  },
  type: {
    uk: 'Тип',
    en: 'Type',
    es: 'Tipo',
    ru: 'Тип',
  },
  delivery_order: {
    uk: 'Замовлення на доставку',
    en: 'Delivery Order',
    es: 'Pedido a domicilio',
    ru: 'Заказ на доставку',
  },
  create_order: {
    uk: 'Створити замовлення',
    en: 'Create Order',
    es: 'Crear pedido',
    ru: 'Создать заказ',
  },
  telegram_notifications: {
    uk: 'Сповіщення в Telegram',
    en: 'Telegram Notifications',
    es: 'Notificaciones en Telegram',
    ru: 'Уведомления в Telegram',
  },
  no_account_found: {
    uk: 'Здається, такого облікового запису ще немає. Давайте зареєструємось?',
    en: "It seems there is no account like that. Let's register?",
    es: 'Parece que no hay una cuenta como esa. ¿Quieres registrarte?',
    ru: 'Похоже, такого аккаунта еще нет. Давайте зарегистрируемся?',
  },
  background_color: {
    uk: 'Колір фону',
    en: 'Background Color',
    es: 'Color de fondo',
    ru: 'Цвет фона',
  },
  primary_color: {
    uk: 'Основний колір',
    en: 'Primary Color',
    es: 'Color principal',
    ru: 'Основной цвет',
  },
  per_day: {
    uk: 'За день',
    en: 'Per Day',
    es: 'Por día',
    ru: 'За день',
  },
  per_week: {
    uk: 'За тиждень',
    en: 'Per Week',
    es: 'Por semana',
    ru: 'За неделю',
  },
  per_month: {
    uk: 'За місяць',
    en: 'Per Month',
    es: 'Por mes',
    ru: 'За месяц',
  },
  empty_key: {
    uk: '',
    en: '',
    es: '',
    ru: '',
  },
  fiscalize: {
    uk: 'Фіскалізувати через ПРРО',
    en: 'Fiscalize',
    es: 'Fiscalizar',
    ru: 'Фискализировать через ПРРО',
  },
  vat: {
    uk: 'ПДВ',
    en: 'VAT',
    es: 'IVA',
    ru: 'НДС',
  },
  excise_tax: {
    uk: 'Акцизний збір',
    en: 'Excise Tax',
    es: 'Impuesto de Acceso',
    ru: 'Акцизный сбор',
  },
  work_shift_tracking: {
    uk: 'Облік робочих змін в POS терміналі',
    en: 'Work Shift Tracking in POS Terminal',
    es: 'Seguimiento de Turnos de Trabajo en Terminal POS',
    ru: 'Учет рабочих смен в POS терминале',
  },
  open_close_pos_shifts: {
    uk: 'Відкривати і закривати робочі зміни в POS терміналі',
    en: 'Open and Close Work Shifts in POS Terminal',
    es: 'Abrir y Cerrar Turnos de Trabajo en Terminal POS',
    ru: 'Открывать и закрывать рабочие смены в POS терминале',
  },
  delete_items_in_order: {
    uk: 'Видаляти позиції в замовленні',
    en: 'Delete Items in Order',
    es: 'Eliminar ítems del pedido',
    ru: 'Удалять позиции в заказе',
  },
  shift_not_open: {
    uk: 'Наразі робоча зміна ще не відкрита',
    en: 'The work shift is not open yet',
    es: 'El turno de trabajo aún no está abierto',
    ru: 'На данный момент рабочая смена еще не открыта',
  },
  open_shift: {
    uk: 'Відкрити робочу зміну',
    en: 'Open Work Shift',
    es: 'Abrir Turno de Trabajo',
    ru: 'Открыть рабочую смену',
  },
  check_cash_balance: {
    uk: 'Перед початком робочої зміни перевірте баланс каси і рахунків',
    en: 'Before starting your work shift, check the cash and account balances',
    es: 'Antes de comenzar tu turno de trabajo, verifica los saldos de efectivo y cuentas',
    ru: 'Перед началом рабочей смены проверьте баланс кассы и счетов',
  },
  check_cash_balance_before_closing: {
    uk: 'Перед закриттям робочої зміни перевірте баланс каси і рахунків',
    en: 'Before closing your work shift, check the cash and account balances',
    es: 'Antes de cerrar tu turno de trabajo, verifica los saldos de efectivo y cuentas',
    ru: 'Перед закрытием рабочей смены проверьте баланс кассы и счетов',
  },
  close_shift: {
    uk: 'Закрити зміну',
    en: 'Close shift',
    es: 'Cerrar turno',
    ru: 'Закрыть смену',
  },
  pos_shift_archive: {
    uk: 'Архів POS змін',
    en: 'POS Shift Archive',
    es: 'Archivo de turnos POS',
    ru: 'Архив POS смен',
  },
  shift_start_balance: {
    uk: 'Баланс на початку зміни',
    en: 'Starting Balance',
    es: 'Saldo al inicio del turno',
    ru: 'Баланс на начало смены',
  },
  shift_end_balance: {
    uk: 'Баланс в кінці зміни',
    en: 'Ending Balance',
    es: 'Saldo al final del turno',
    ru: 'Баланс на конец смены',
  },
  extend_subscription: {
    uk: 'Подовжити підписку',
    en: 'Extend Subscription',
    es: 'Renovar suscripción',
    ru: 'Продлить подписку',
  },
  extend_for_month: {
    uk: 'Подовжити на місяць',
    en: 'Extend for a Month',
    es: 'Extender por un mes',
    ru: 'Продлить на месяц',
  },
  extend_for_year: {
    uk: 'Подовжити на рік',
    en: 'Extend for a Year',
    es: 'Extender por un año',
    ru: 'Продлить на год',
  },
  subscription_expires_on: {
    uk: 'Термін дії вашої підписки закінчується',
    en: 'Your subscription expires on',
    es: 'Su suscripción vence el',
    ru: 'Срок действия вашей подписки истекает',
  },
  attention: {
    uk: 'Увага!',
    en: 'Attention!',
    es: '¡Atención!',
    ru: 'Внимание!',
  },
  something_went_wrong: {
    uk: 'Упс, щось пішло не так. Будь ласка, зверніться до нашої підтримки за телефоном: +38 097 682 98 56',
    en: 'Oops, something went wrong. Please contact our support at: +34 685 557 997',
    es: 'Ups, algo salió mal. Por favor, contacte con nuestro soporte al: +34 685 557 997',
    ru: 'Упс, что-то пошло не так. Пожалуйста, свяжитесь с нашей поддержкой по телефону: +34 685 557 997',
  },
  thank_you_for_ordering: {
    uk: 'Дякуємо! Ми отримали Ваше замовлення і скоро почнемо його готувати',
    en: 'Thank you! We have received your order and will start preparing it soon',
    es: '¡Gracias! Hemos recibido su pedido y comenzaremos a prepararlo pronto',
    ru: 'Спасибо! Мы получили Ваш заказ и скоро начнем его готовить',
  },
  token_for_internet_acquiring: {
    uk: 'Токен для інтернет-еквайрингу',
    en: 'Token for Internet Acquiring',
    es: 'Token para Adquisición en Internet',
    ru: 'Токен для интернет-эквайринга',
  },
  cancel_payment: {
    uk: 'Скасувати оплату',
    en: 'Cancel Payment',
    es: 'Cancelar Pago',
    ru: 'Отменить оплату',
  },
  cancel_payment_confirmation: {
    uk: 'Ви впевнені, що бажаєте скасувати оплату та закриття замовлення?',
    en: 'Are you sure you want to cancel the payment and close the order?',
    es: '¿Está seguro de que desea cancelar el pago y cerrar el pedido?',
    ru: 'Вы уверены, что хотите отменить оплату и закрыть заказ?',
  },
  fiscalized_receipt_warning: {
    uk: 'Увага! Цей чек було фіскалізовано. Після скасування оплати, необхідно додатково зробити повернення чеку в кабінеті провайдера ПРРО.',
    en: "Attention! This receipt has been fiscalized. After canceling the payment, it is additionally required to process the return of the receipt in the provider's RRO cabinet.",
    es: '¡Atención! Este recibo ha sido fiscalizado. Después de cancelar el pago, es necesario procesar adicionalmente la devolución del recibo en el gabinete del proveedor RRO.',
    ru: 'Внимание! Этот чек был фискализирован. После отмены оплаты, необходимо дополнительно сделать возврат чека в кабинете провайдера ПРРО.',
  },
  payment_canceled: {
    uk: 'Оплата скасована',
    en: 'Payment Canceled',
    es: 'Pago Cancelado',
    ru: 'Оплата отменена',
  },
  payment_cancellation_message: {
    uk: 'Скасування оплати за замовлення',
    en: 'Cancellation of payment for the order',
    es: 'Cancelación del pago por el pedido',
    ru: 'Отмена оплаты за заказ',
  },
  to_cancel_payment: {
    uk: 'Скасовувати оплату',
    en: 'Cancel Payment',
    es: 'Cancelar Pago',
    ru: 'Отменить оплату',
  },
  promotions: {
    uk: 'Акції',
    en: 'Promotions',
    es: 'Promociones',
    ru: 'Акции',
  },
  add_promotion: {
    uk: 'Додати акцію',
    en: 'Add promotion',
    es: 'Añadir promoción',
    ru: 'Добавить акцию',
  },
  marketing: {
    uk: 'Маркетинг',
    en: 'Marketing',
    es: 'Marketing',
    ru: 'Маркетинг',
  },
  promotion: {
    uk: 'Акція',
    en: 'Promotion',
    es: 'Promoción',
    ru: 'Акция',
  },
  display_banner_in_qr_menu: {
    uk: 'Відображати банер з акцією в QR меню',
    en: 'Display promotion banner in QR menu',
    es: 'Mostrar banner de promoción en el menú QR',
    ru: 'Отображать баннер с акцией в QR меню',
  },
  start_date: {
    uk: 'Дата початку',
    en: 'Start date',
    es: 'Fecha de inicio',
    ru: 'Дата начала',
  },
  end_date: {
    uk: 'Дата закінення',
    en: 'End date',
    es: 'Fecha de finalización',
    ru: 'Дата окончания',
  },
  discount_type: {
    uk: 'Тип знижки',
    en: 'Type of discount',
    es: 'Tipo de descuento',
    ru: 'Тип скидки',
  },
  fixed_discount: {
    uk: 'Фіксована знижка',
    en: 'Fixed discount',
    es: 'Descuento fijo',
    ru: 'Фиксированная скидка',
  },
  discount_applies_if_order_includes: {
    uk: 'Знижка застосовується, якщо в замовленні є:',
    en: 'Discount applies if the order includes:',
    es: 'El descuento se aplica si el pedido incluye:',
    ru: 'Скидка применяется, если в заказе есть:',
  },
  add_condition: {
    uk: 'Додати умову',
    en: 'Add condition',
    es: 'Añadir condición',
    ru: 'Добавить условие',
  },
  hours_promotion_applies: {
    uk: 'Години, в які застосовується акція',
    en: 'Hours during which the promotion applies',
    es: 'Horas durante las cuales se aplica la promoción',
    ru: 'Часы, в которые действует акция',
  },
  days_promotion_applies: {
    uk: 'Дні, в які застосовується акція',
    en: 'Days during which the promotion applies',
    es: 'Días durante los cuales se aplica la promoción',
    ru: 'Дни, в которые действует акция',
  },
  create_and_edit_promotions: {
    uk: 'Створювати та редагувати акції',
    en: 'Create and edit promotions',
    es: 'Crear y editar promociones',
    ru: 'Создавать и редактировать акции',
  },
  combination: {
    uk: 'Комбінація',
    en: 'Combination',
    es: 'Combinación',
    ru: 'Комбинация',
  },
  add_combination: {
    uk: 'Додати комбінацію',
    en: 'Add combination',
    es: 'Añadir combinación',
    ru: 'Добавить комбинацию',
  },
  delete_combination: {
    uk: 'Видалити комбінацію',
    en: 'Delete combination',
    es: 'Eliminar combinación',
    ru: 'Удалить комбинацию',
  },
  confirm_delete_promotion: {
    uk: 'Ви впевнені, що бажаєте видалити цю акцію?',
    en: 'Are you sure you want to delete this promotion?',
    es: '¿Está seguro de que desea eliminar esta promoción?',
    ru: 'Вы уверены, что хотите удалить эту акцию?',
  },
  scheduled: {
    uk: 'Запланована',
    en: 'Scheduled',
    es: 'Programada',
    ru: 'Запланирована',
  },
  active: {
    uk: 'Активна',
    en: 'Active',
    es: 'Activa',
    ru: 'Активна',
  },
  completed: {
    uk: 'Завершена',
    en: 'Completed',
    es: 'Completada',
    ru: 'Завершена',
  },
  dark_theme: {
    uk: 'Темна тема',
    en: 'Dark Theme',
    es: 'Tema Oscuro',
    ru: 'Темная тема',
  },
  legal_entities: {
    uk: 'Юридичні особи',
    en: 'Legal Entities',
    es: 'Entidades Legales',
    ru: 'Юридические лица',
  },
  add_legal_entity: {
    uk: 'Додати юридичну особу',
    en: 'Add Legal Entity',
    es: 'Añadir Entidad Legal',
    ru: 'Добавить юридическое лицо',
  },
  legal_entity: {
    uk: 'Юридична особа',
    en: 'Legal Entity',
    es: 'Entidad Legal',
    ru: 'Юридическое лицо',
  },
  tax_information: {
    uk: 'Податкова інформація',
    en: 'Tax Information',
    es: 'Información Fiscal',
    ru: 'Налоговая информация',
  },
  any: {
    uk: 'Будь-яка',
    en: 'Any',
    es: 'Cualquiera',
    ru: 'Любая',
  },
  clients: {
    uk: 'Клієнти',
    en: 'Clients',
    es: 'Clientes',
    ru: 'Клиенты',
  },
  client: {
    uk: 'Клієнт',
    en: 'Client',
    es: 'Cliente',
    ru: 'Клиент',
  },
  add_and_edit_clients: {
    uk: 'Додавати та редагувати клієнтів',
    en: 'Add and Edit Clients',
    es: 'Agregar y Editar Clientes',
    ru: 'Добавлять и редактировать клиентов',
  },
  select_client_in_order: {
    uk: 'Обирати клієнта в замовленні',
    en: 'Select Client in Order',
    es: 'Seleccionar Cliente en Pedido',
    ru: 'Выбирать клиента в заказе',
  },
  set_personal_discount: {
    uk: 'Встановлювати персональну знижку',
    en: 'Set Personal Discount',
    es: 'Establecer Descuento Personal',
    ru: 'Устанавливать персональную скидку',
  },
  client_groups: {
    uk: 'Групи клієнтів',
    en: 'Client Groups',
    es: 'Grupos de Clientes',
    ru: 'Группы клиентов',
  },
  add_client: {
    uk: 'Додати клієнта',
    en: 'Add Client',
    es: 'Añadir Cliente',
    ru: 'Добавить клиента',
  },
  date_of_birth: {
    uk: 'Дата народження',
    en: 'Date of Birth',
    es: 'Fecha de Nacimiento',
    ru: 'Дата рождения',
  },
  determined_automatically: {
    uk: 'Визначається автоматично',
    en: 'Determined Automatically',
    es: 'Determinado Automáticamente',
    ru: 'Определяется автоматически',
  },
  individual_discount: {
    uk: 'Індивідуальна знижка',
    en: 'Individual Discount',
    es: 'Descuento Individual',
    ru: 'Индивидуальная скидка',
  },
  spent_amount: {
    uk: 'Витрачена сума',
    en: 'Amount Spent',
    es: 'Cantidad Gastada',
    ru: 'Потраченная сумма',
  },
  add_client_group: {
    uk: 'Додати групу клієнтів',
    en: 'Add Client Group',
    es: 'Añadir Grupo de Clientes',
    ru: 'Добавить группу клиентов',
  },
  client_group: {
    uk: 'Група клієнтів',
    en: 'Client Group',
    es: 'Grupo de Clientes',
    ru: 'Группа клиентов',
  },
  client_with_phone_number_exists: {
    uk: 'Клієнт з таким номером телефону вже існує',
    en: 'A client with this phone number already exists',
    es: 'Ya existe un cliente con este número de teléfono',
    ru: 'Клиент с таким номером телефона уже существует',
  },
  select_client: {
    uk: 'Обрати клієнта',
    en: 'Select Client',
    es: 'Seleccionar Cliente',
    ru: 'Выбрать клиента',
  },
  client_does_not_exist: {
    uk: 'Такого клієнта не існує',
    en: 'Such a client does not exist',
    es: 'Tal cliente no existe',
    ru: 'Такого клиента не существует',
  },
  client_changed: {
    uk: 'Змінено клієнта',
    en: 'Client Changed',
    es: 'Cliente Cambiado',
    ru: 'Клиент изменен',
  },
  without_client: {
    uk: 'Без клієнта',
    en: 'Without Client',
    es: 'Sin Cliente',
    ru: 'Без клиента',
  },
  loyalty_program: {
    uk: 'Програма лояльності',
    en: 'Loyalty Program',
    es: 'Programa de Lealtad',
    ru: 'Программа лояльности',
  },
  cumulative_discount_system: {
    uk: 'Накопичувальна система знижок',
    en: 'Cumulative Discount System',
    es: 'Sistema de Descuentos Acumulativos',
    ru: 'Накопительная система скидок',
  },
  add_step: {
    uk: 'Додати крок',
    en: 'Add Step',
    es: 'Añadir Paso',
    ru: 'Добавить шаг',
  },
  tariffs: {
    uk: 'Тарифи',
    en: 'Tariffs',
    es: 'Tarifas',
    ru: 'Тарифы',
  },
  display_service_charge_message: {
    uk: 'Відображати повідомлення про плату за обслуговування',
    en: 'Display Service Charge Message',
    es: 'Mostrar Mensaje de Cargo por Servicio',
    ru: 'Отображать сообщение о плате за обслуживание',
  },
  cost_price: {
    uk: 'Собівартість',
    en: 'Cost Price',
    es: 'Precio de Costo',
    ru: 'Себестоимость',
  },
  of_price: {
    uk: 'від ціни',
    en: 'of the Price',
    es: 'del Precio',
    ru: 'от цены',
  },
  output_volume: {
    uk: "Вихідний об'єм",
    en: 'Output Volume',
    es: 'Volumen de Salida',
    ru: 'Выходной объем',
  },
  report_byDishes: {
    uk: 'Звіт по позиціям',
    en: 'Item Report',
    es: 'Informe por Artículos',
    ru: 'Отчет по позициям',
  },
  report_byStores: {
    uk: 'Звіт по складам',
    en: 'Warehouse Report',
    es: 'Informe de Almacén',
    ru: 'Отчет по складам',
  },
  report_byWallets: {
    uk: 'Фінансовий звіт',
    en: 'Financial report',
    es: 'Informe financiero',
    ru: 'Финансовый отчет',
  },
  report_bySales: {
    uk: 'Звіт по продажам',
    en: 'Sales Report',
    es: 'Informe de Ventas',
    ru: 'Отчет по продажам',
  },
  semi_finished_products_production: {
    uk: 'Виробництво напівфабрикатів',
    en: 'Semi-finished Products Production',
    es: 'Producción de Productos Semielaborados',
    ru: 'Производство полуфабрикатов',
  },
  movement: {
    uk: 'Переміщення',
    en: 'Movement',
    es: 'Movimiento',
    ru: 'Перемещение',
  },
  menu_item_production: {
    uk: 'Виробництво позицій меню',
    en: 'Menu Item Production',
    es: 'Producción de Ítems del Menú',
    ru: 'Производство позиций меню',
  },
  unknown: {
    uk: 'Невідомо',
    en: 'Unknown',
    es: 'Desconocido',
    ru: 'Неизвестно',
  },
  estimated_cost_price: {
    uk: 'Орієнтовна собівартість',
    en: 'Estimated Cost Price',
    es: 'Precio de Costo Estimado',
    ru: 'Ориентировочная себестоимость',
  },
  interested_in_feature: {
    uk: 'Ми раді, що ви зацікавлені використовувати цей функціонал! ',
    en: 'We are glad you are interested in using this feature! ',
    es: '¡Nos alegra que estés interesado en utilizar esta funcionalidad! ',
    ru: 'Мы рады, что вы заинтересованы в использовании этой функции! ',
  },
  feature_available_plus_pro: {
    uk: 'Однак, ця функція доступна тільки для наших PLUS та PRO планів.',
    en: 'However, this feature is available only for our PLUS and PRO plans.',
    es: 'Sin embargo, esta función solo está disponible para nuestros planes PLUS y PRO.',
    ru: 'Однако, эта функция доступна только для наших PLUS и PRO планов.',
  },
  feature_available_pro: {
    uk: 'Однак, ця функція доступна тільки для нашого PRO плану.',
    en: 'However, this feature is available only for our PRO plan.',
    es: 'Sin embargo, esta función solo está disponible para nuestro plan PRO.',
    ru: 'Однако, эта функция доступна только для нашего PRO плана.',
  },
  upgrade_to_plus_pro: {
    uk: 'Перехід на PLUS або PRO план відкриває вам доступ до цієї та багатьох інших преміум-функцій, які допоможуть вам отримати максимальну вигоду від нашого продукту.',
    en: 'Upgrading to the PLUS or PRO plan gives you access to this and many other premium features that will help you make the most of our product.',
    es: 'La actualización al plan PLUS o PRO te brinda acceso a esta y muchas otras funciones premium que te ayudarán a sacar el máximo provecho de nuestro producto.',
    ru: 'Переход на PLUS или PRO план открывает вам доступ к этой и многим другим премиум-функциям, которые помогут вам получить максимальную пользу от нашего продукта.',
  },
  upgrade_to_pro: {
    uk: 'Перехід на PRO план відкриває вам доступ до цієї та багатьох інших преміум-функцій, які допоможуть вам отримати максимальну вигоду від нашого продукту.',
    en: 'Upgrading to the PRO plan gives you access to this and many other premium features that will help you make the most of our product.',
    es: 'La actualización al plan PRO te brinda acceso a esta y muchas otras funciones premium que te ayudarán a sacar el máximo provecho de nuestro producto.',
    ru: 'Переход на PRO план открывает вам доступ к этой и многим другим премиум-функциям, которые помогут вам получить максимальную пользу от нашего продукта.',
  },
  plan_expired: {
    uk: 'Однак, термін дії вашого тарифного плану скінчився. Будь ласка, оновіть ваш тарифний план.',
    en: 'However, your tariff plan has expired. Please, renew your tariff plan.',
    es: 'Sin embargo, el plazo de su plan tarifario ha expirado. Por favor, renueve su plan tarifario.',
    ru: 'Однако срок действия вашего тарифного плана истек. Пожалуйста, обновите ваш тарифный план.',
  },
  upgrade_instructions1: {
    uk: 'Щоб оновити свій план, просто перейдіть до розділу ',
    en: 'To upgrade your plan, simply go to the ',
    es: 'Para actualizar tu plan, simplemente ve a la sección de ',
    ru: 'Чтобы обновить ваш план, просто перейдите в раздел ',
  },
  upgrade_instructions2: {
    uk: 'Налаштування ресторану',
    en: 'Restaurant Settings section',
    es: 'Configuración del Restaurante',
    ru: 'Настройки ресторана',
  },
  upgrade_plan: {
    uk: 'Оновити план',
    en: 'Upgrade Plan',
    es: 'Actualizar Plan',
    ru: 'Обновить план',
  },
  welcome_to_firemenu_world: {
    uk: 'Вітаємо у світі FireMenu! 🥳',
    en: 'Welcome to the world of FireMenu! 🥳',
    es: '¡Bienvenido al mundo de FireMenu! 🥳',
    ru: 'Добро пожаловать в мир FireMenu! 🥳',
  },
  chosen_recipe: {
    uk: 'Нам дуже приємно, що ви обрали саме наш рецепт автоматизації для досягнення кулінарного успіху! 🍲🌟',
    en: 'We are delighted that you have chosen our recipe for automation to achieve culinary success! 🍲🌟',
    es: 'Estamos encantados de que haya elegido nuestra receta de automatización para lograr el éxito culinario! 🍲🌟',
    ru: 'Мы очень рады, что вы выбрали именно наш рецепт автоматизации для достижения кулинарного успеха! 🍲🌟',
  },
  before_you_dive: {
    uk: 'Перш ніж ви зануритесь у наші смачні можливості, ось коротка інформація, яка зробить ваше знайомство з FireMenu легким та приємним:',
    en: "Before you dive into our delicious possibilities, here's some brief information to make your acquaintance with FireMenu easy and enjoyable:",
    es: 'Antes de sumergirse en nuestras deliciosas posibilidades, aquí hay información breve para que su conocimiento de FireMenu sea fácil y agradable:',
    ru: 'Прежде чем вы окунетесь в наши вкусные возможности, вот краткая информация, которая сделает ваше знакомство с FireMenu легким и приятным:',
  },
  loyal_assistants: {
    uk: 'Ваші вірні помічники - іконки "Інформація" ',
    en: 'Your loyal assistants - the "Information" icons ',
    es: 'Sus leales ayudantes: los iconos de "Información" ',
    ru: 'Ваши верные помощники - иконки "Информация" ',
  },
  loyal_assistants2: {
    uk: ', розташовані в кожному розділі програми. Натисніть на них, щоб отримати корисні поради та інструкції.',
    en: ', located in each section of the program. Click on them to get useful tips and instructions.',
    es: ', ubicados en cada sección del programa. Haga clic en ellos para obtener consejos útiles e instrucciones.',
    ru: ', расположенные в каждом разделе программы. Нажмите на них, чтобы получить полезные советы и инструкции.',
  },
  encountered_obstacle: {
    uk: 'Натрапили на перешкоду? Не хвилюйтеся! Натисніть на іконку чата ',
    en: "Encountered an obstacle? Don't worry! Click on the chat icon ",
    es: '¿Encontró un obstáculo? ¡No se preocupe! Haga clic en el ícono del chat ',
    ru: 'Столкнулись с препятствием? Не волнуйтесь! Нажмите на иконку чата ',
  },
  encountered_obstacle2: {
    uk: ', і наші фахівці техпідтримки завжди будуть поруч, щоб допомогти вам.',
    en: ', and our technical support specialists will always be there to help you.',
    es: ', y nuestros especialistas en soporte técnico siempre estarán ahí para ayudarle.',
    ru: ', и наши специалисты техподдержки всегда будут рядом, чтобы помочь вам.',
  },
  next_step: {
    uk: 'Наступним кроком буде наш путівник, який допоможе вам швидко налаштувати та ознайомитися з програмою. Просто слідуйте крокам, і ви будете готові до старту!',
    en: "The next step will be our guide, which will help you quickly set up and familiarize yourself with the program. Simply follow the steps, and you'll be ready to go!",
    es: 'El siguiente paso será nuestra guía, que le ayudará a configurar rápidamente y familiarizarse con el programa. ¡Simplemente siga los pasos y estará listo para comenzar!',
    ru: 'Следующим шагом будет наш путеводитель, который поможет вам быстро настроить и ознакомиться с программой. Просто следуйте шагам, и вы будете готовы к старту!',
  },
  open_to_suggestions: {
    uk: 'Ми завжди відкриті до ваших пропозицій та відгуків! Якщо у вас є ідеї щодо покращення FireMenu, ми з радістю вислухаємо і врахуємо вашу думку. Давайте вдосконалюватись разом!',
    en: "We are always open to your suggestions and feedback! If you have ideas for improving FireMenu, we would be happy to listen and take your opinion into account. Let's improve together!",
    es: '¡Siempre estamos abiertos a sus sugerencias y comentarios! Si tiene ideas para mejorar FireMenu, estaremos encantados de escuchar y tener en cuenta su opinión. ¡Mejoremos juntos!',
    ru: 'Мы всегда открыты к вашим предложениям и отзывам! Если у вас есть идеи по улучшению FireMenu, мы с радостью выслушаем и учтем ваше мнение. Давайте совершенствоваться вместе!',
  },
  best_wishes: {
    uk: 'З найкращими побажаннями,',
    en: 'Best wishes,',
    es: 'Con los mejores deseos,',
    ru: 'С наилучшими пожеланиями,',
  },
  firemenu_team: {
    uk: 'Команда FireMenu',
    en: 'FireMenu Team',
    es: 'Equipo de FireMenu',
    ru: 'Команда FireMenu',
  },
  lets_go: {
    uk: 'Поїхали',
    en: "Let's go",
    es: 'Vamos',
    ru: 'Поехали',
  },
  step1_part1: {
    uk: 'Якщо ви бажаєте вести облік продуктів та напівфабрикатів на складі, небхідно зробити наступне:',
    en: 'If you want to keep track of products and semi-finished products in stock, you need to do the following:',
    es: 'Si desea llevar un registro de los productos y semielaborados en stock, debe hacer lo siguiente:',
    ru: 'Если вы хотите вести учет продуктов и полуфабрикатов на складе, необходимо сделать следующее:',
  },
  step1_part2: {
    uk: 'Додайте хоча б один склад у розділі',
    en: 'Add at least one storage in the section',
    es: 'Agregue al menos un almacén en la sección',
    ru: 'Добавьте хотя бы один склад в разделе',
  },
  step1_part3: {
    uk: 'Додайте всі продукти, які ви замовляєте у постачальників, у розділ',
    en: 'Add all products that you order from suppliers to the section',
    es: 'Agregue todos los productos que solicite a los proveedores a la sección',
    ru: 'Добавьте все продукты, которые вы заказываете у поставщиков, в раздел',
  },
  step1_part4: {
    uk: 'Якщо ви готуєте якісь напівфабрикати, додайте їх в розділі',
    en: 'If you are preparing any semi-finished products, add them in the section',
    es: 'Si está preparando algún producto semielaborado, agréguelos en la sección',
    ru: 'Если вы готовите какие-либо полуфабрикаты, добавьте их в разделе',
  },
  step2_part1: {
    uk: 'Заповніть меню вашого ресторану вашими кулінарними шедеврами в розділі',
    en: 'Fill the menu of your restaurant with your culinary masterpieces in the section',
    es: 'Llene el menú de su restaurante con sus obras maestras culinarias en la sección',
    ru: 'Заполните меню вашего ресторана вашими кулинарными шедеврами в разделе',
  },
  step3_part1: {
    uk: 'Якщо ви бажаєте вести фінансовий облік та отримувати детальні фінансові звіти, давайте додамо ваші ',
    en: "If you want to keep financial records and receive detailed financial reports, let's add your ",
    es: 'Si desea llevar un registro financiero y recibir informes financieros detallados, agreguemos sus ',
    ru: 'Если вы хотите вести финансовый учет и получать детальные финансовые отчеты, давайте добавим ваши ',
  },
  step3_part2: {
    uk: '. Це можуть бути як банківські рахунки, так і фізичні каси вашого ресторану.',
    en: '. These can be both bank accounts and physical cash registers of your restaurant.',
    es: '. Estas pueden ser tanto cuentas bancarias como cajas registradoras físicas de su restaurante.',
    ru: '. Это могут быть как банковские счета, так и физические кассы вашего ресторана.',
  },
  step4_part1: {
    uk: 'Тепер давайте додамо всіх працівників у розділі ',
    en: "Now let's add all employees in the ",
    es: 'Ahora agreguemos a todos los empleados en la sección de ',
    ru: 'Теперь давайте добавим всех сотрудников в разделе ',
  },
  step4_part2: {
    uk: ' та назначимо ',
    en: ' section and set their ',
    es: ' y programemos sus ',
    ru: ' и назначим ',
  },
  step4_part3: {
    uk: '. Після цього ваші працівники будуть мати персональний доступ до FireMenu, згідно налаштованих прав доступу.',
    en: '. After this, your employees will have personal access to FireMenu according to the configured access rights.',
    es: '. Después de esto, sus empleados tendrán acceso personal a FireMenu de acuerdo con los derechos de acceso configurados.',
    ru: '. После этого ваши сотрудники будут иметь персональный доступ к FireMenu, согласно настроенным правам доступа.',
  },
  step5_part1: {
    uk: 'Останній акорд! Відвідайте розділ ',
    en: 'Last chord! Visit the ',
    es: '¡Último acorde! Visite la sección ',
    ru: 'Последний аккорд! Посетите раздел ',
  },
  step5_part2: {
    uk: ', щоб зробити фінальні налаштування вашого закладу. Після цього ви будете абсолютно готові до використання всіх можливостей FireMenu. Успіхів вам у підкоренні кулінарних вершин разом з нашою програмою!',
    en: ' section to make the final settings for your establishment. After that, you will be absolutely ready to use all the features of FireMenu. Good luck in conquering culinary heights with our program!',
    es: ' para hacer los ajustes finales para su establecimiento. Después de eso, estará absolutamente listo para utilizar todas las características de FireMenu. ¡Buena suerte en la conquista de las alturas culinarias con nuestro programa!',
    ru: ', чтобы сделать финальные настройки вашего заведения. После этого вы будете абсолютно готовы к использованию всех возможностей FireMenu. Успехов вам в покорении кулинарных вершин вместе с нашей программой!',
  },
  self_order_points: {
    uk: 'Точки самозамовлення',
    en: 'Self-ordering kiosks',
    es: 'Quioscos de auto-pedido',
    ru: 'Точки самообслуживания',
  },
  add_location: {
    uk: 'Додати точку',
    en: 'Add location',
    es: 'Añadir ubicación',
    ru: 'Добавить точку',
  },
  self_order_point: {
    uk: 'Точка самозамовлення',
    en: 'Self-ordering kiosk',
    es: 'Quiosco de auto-pedido',
    ru: 'Точка самообслуживания',
  },
  open_orders: {
    uk: 'Відкриті замовлення',
    en: 'Open orders',
    es: 'Pedidos abiertos',
    ru: 'Открытые заказы',
  },
  closed_orders: {
    uk: 'Закриті замовлення',
    en: 'Closed orders',
    es: 'Pedidos cerrados',
    ru: 'Закрытые заказы',
  },
  in_house_sales: {
    uk: 'Продажі в закладі',
    en: 'In-house sales',
    es: 'Ventas en el establecimiento',
    ru: 'Продажи в заведении',
  },
  bank_commission: {
    uk: 'Комісія банку',
    en: 'Bank commission',
    es: 'Comisión bancaria',
    ru: 'Комиссия банка',
  },
  tips: {
    uk: 'Чайові',
    en: 'Tips',
    es: 'Propinas',
    ru: 'Чаевые',
  },
  commission: {
    uk: 'Комісія',
    en: 'Commission',
    es: 'Comisión',
    ru: 'Комиссия',
  },
  expenses: {
    uk: 'Витрати',
    en: 'Expenses',
    es: 'Gastos',
    ru: 'Расходы',
  },
  bottom_margin: {
    uk: 'Нижній відступ',
    en: 'Bottom margin',
    es: 'Margen inferior',
    ru: 'Нижний отступ',
  },
};
